import React from 'react';
import jsyaml from 'js-yaml';
import LeftNav from './../../common/leftnav/leftnav';
import HeaderTop from '../../common/headerTop/headerTop';
import $ from 'jquery';
import { ServerService as instanceService } from './../../../services/server.service';
import CommonMessage from './../../common/commonMessage';
import { SshkeyService } from '../../../services/sshkey.service';
import Distribution from './../../../statisjsondata/Distribution';
import ReactTooltip from 'react-tooltip';
import { distributionOption, appStack } from './createInstance.Constant';
import { getUnique, formatBytes, formatBytesFloat, getRandomPassword, formatBandwidthBytes, convertgbtotb, isKeyValid } from '../../../utility/utility';
import { AuditLog } from './../../../services/auditlog.service';
import RegionService from '../../../services/region.service';
import DedicatedCpu from './dedicatedcpu';
//import './../Region.css';
import { withStyles } from "@material-ui/styles";
import { ResourceService } from './../../../services/resource.service';
import Flavours from './../../../statisjsondata/Flavours';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import FlavorService from '../../../services/flavor.service';
import { axiosInstance, REVIEWER_EMAIL, REVIEWER_REGION, KB_ARTICLES_DOC } from '../../../constants/server.constant';
import { getMessage } from '../../../constants/messagesMapper';
import NotificationSlider from '../../common/topRightHeader/notificationSlider';
import { userService } from '../../../services/user.service';
import { SessionService } from './../../../services/session.service';
import AppImages from '../../../statisjsondata/AppImages';
import { API_HOST, axiosRequestWithAuth } from '../../../constants/server.constant';
import { loginService } from '../../../services/login.service';
//import './createInstance.css';
const styles = theme => ({
    overrideMe: {
        width: "800px",
        "word-break": "break-all",
        "overflow-wrap": "break-word",
        display: "block"
    }
});
class CreateInstance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            instanceForm: {
                region: '',
                regionCapcity: '',
                sshPublickey: '',
                sshName: '',
                sshKeys: [],
                isBackupEnabled: true,
                unitName: '',
                unit: 1,
                privateIp: false,
                userData: '',
                password: '',
                distName: '',
                version: '',
                instSet: '',
                name: '',
                ram: '',
                processor: '',
                storage: '',
                flavorRefId: '',
                imageRefId: '',
                flavorType: '',
                monthlyRate: '0',
                message: '',
                msgType: '',
                distrVersionName: '',
                isUserData: false,
                parentProc: '',
                diskType: '',
                threads: '',

            },
            keyName: '',
            sshKeys: [],
            regionList: [],
            images: [],
            distributionImages: [],
            uniqueDistImages: [],
            instancePlans: [],
            bareMetalImagesUnique: [],
            bareMetalImages: [],
            dcpuList: [],
            instanceFilterPlans: [],
            sshPublickey: false,
            sshEmpty: false,
            sshKeyRegex: false,
            isUnitNameFocused: false,
            hidePwd: false,
            psswdStrength: 'Strong',
            isAction: false,
            errorMessg: '',
            selectedRegionUrl: '',
            computeRegionList: [],
            sshAuthorizedKeys: [],
            uuidList: [],
            distributeDisplay: 'block',
            regionListFilter: [],
            regions: [],
            countryName: '',
            isScpu: true,
            dropRegion: '',
            regionErrorMsg: '',
            isCreateDisabled: true,
            isCreateExternalDisabled: !loginService.isInternalUser(),
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            isLoginData: '#cloud-config\nruncmd:\n  - [\'sed\', \'-E\', \'-i\', \'s\/^[ #]*(PermitRootLogin|PasswordAuthentication|ChallengeResponseAuthentication) .*\/\\1 yes\/\', \'\/etc\/ssh\/sshd_config\']\n  - [\'systemctl\', \'restart\', \'sshd\']',
            eightCharLi: true,
            oneUpperLi: true,
            oneNumSpeLi: true,
            noNumSpeLi: true,
            isSshKey: true,
            isYearly: false,
            isPrepaidMonthly: true,

            discPerce: '',
            discMonPerce: '',
            discVal: '',
            discCode: '',
            availabilityZone: '',
            email: localStorage.getItem('email'),
            applicationStack: [],
            appSlider: {
                packages: [],
                heading1Desc: [],
                heading2Desc: [],
            },
            skipLimit: true,
            isBmr: false,
            bmPlanAvail: "",
            bmrProcessor: "",
            bmrStorage: "",
            bmrRam: "",
            bmrOfferVal: 0,
            bmrRequestedPlan: "",
            isBMRConfrimPopup: false,
            bmrPrice: 0,
            bmrFlavorRefId: "",
            bmrLimit: 1,
            bmrFlavourPlans: [],
            bmrQuery: "",
            isRequestSubmitted: true,
            classType: false,
            isPlanAvailable: false,
            bmrParentProc: '',
            bmrThreads: '',
            bmrDiskType: '',
            isCloud: true,
            resourceClass: '',
            showBmrBox: false,
            unitsAvail: '',
            isBMPlan: false,
            showSpeed: false,
            setLink: "",
            Imagesshow: false,
            isBlocked: false,
            userBlockType: "instance",
            isNewContent: true,
            config_drive: false,
            isPasswdDisabled: false,
            isRancher: false,
            kbArticles: [],
            udPlaceHolder: "Enter user-data in cloud config format, e.g.\n# cloud-config\n# Install additional packages on first boot\n# packages may be supplied as a single package name or as a list\n# with the format [<package>, <version>] wherein the specific\n# package version will be installed.\n# packages:\n#  - vim\n#  - git\n#  - [firefox, 78.12.0-1.el8_4 ]"
        };
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.addUnit = this.addUnit.bind(this);
        this.removeUnit = this.removeUnit.bind(this);
        this.formChangeHandler = this.formChangeHandler.bind(this);
        this.addSshkey = this.addSshkey.bind(this);
        this.onMenuIconClick = this.onMenuIconClick.bind(this);
        this.cancel = this.cancel.bind(this);
        this.planBoxClick = this.planBoxClick.bind(this);
        this.planRadioClick = this.planRadioClick.bind(this);
        this.distVersionSelect = this.distVersionSelect.bind(this);
        this.handlesubmit = this.handlesubmit.bind(this);
        this.scrollRef = React.createRef();
        this.setServerType = this.setServerType.bind(this);
        this.checkBmrInputs = this.checkBmrInputs.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.setBmrPlan = this.setBmrPlan.bind(this);
        this.setBmrQueries = this.setBmrQueries.bind(this);
    }
    escfunction(event) {
        if(event.keyCode === 27) {
            $("body").removeClass("no_scroll");
            this.setState({
                isBMRConfrimPopup: false
            });
        }

    }


    formChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if(name === 'unit') {
            val = parseInt(val.replace('Unit', '').replace(' ', '').trim());

            if(isNaN(val) || val === 0) {
                val = '';
            } else if(!Number.isInteger(val)) {
                val = 1;
            }
            else if(this.state.isBmr) {
                if(this.state.isBMPlan && val > this.state.unitsAvail) {
                    val = this.state.unitsAvail;
                }
                else if(val > 25) {
                    val = 25;
                }

            }
            else if(this.state.isScpu && val > 25) {
                val = 25;
            }
            else if(!this.state.isScpu && val > 10) {
                val = 10;
            }
            this.setUnitName(val);
        }
        let form = this.state.instanceForm;
        form[name] = val;
        if(name === 'password') {
            this.setState({ psswdStrength: getPsswdStrength(val), rootErrorMessg: '' });
            var middleCharPatt = new RegExp("[A-Z]");
            var str = val;
            var lastChar = str.charAt(str.length - 1);
            //At least 8 characters long
            if(val.length >= 8) {
                this.setState({
                    eightCharLi: true
                });
            } else {
                this.setState({
                    eightCharLi: false
                });
            }
            var str2 = str.slice(1, -1);
            //Must contain 1 uppercase (first and last characters don’t count)
            if(middleCharPatt.test(str2)) {
                this.setState({
                    oneUpperLi: true
                });
            } else {
                this.setState({
                    oneUpperLi: false
                });
            }
            //Must contain 1 number and 1 special character
            var patt2 = new RegExp("(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])");
            if(patt2.test(str)) {
                this.setState({
                    oneNumSpeLi: true
                });
            } else {
                this.setState({
                    oneNumSpeLi: false
                });
            }
            //Cannot end in a number or special character            
            var lastCharPatt = new RegExp("[A-Za-z]");
            if(lastCharPatt.test(lastChar)) {
                this.setState({
                    noNumSpeLi: true
                });
            } else {
                this.setState({
                    noNumSpeLi: false
                });
            }
        } else if(name === 'unitName') {
            if(val.length > 50) {
                return;
            }
            var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
            if(!nameRegex.test(val)) {
                this.setState({ unitNameErrorMessg: 'Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            } else {
                this.setState({ unitNameErrorMessg: '' });
            }
        } else if(name === 'unit') {
            this.setState({ unitErrorMessg: '' });
        }
        if(name === 'isLoginData') {
            if(val) {
                form.userData = form.userData + this.state.isLoginData;
            } else {
                form.userData = '';
            }
        }
        if(name === 'sshName') {
            var sshRegex = new RegExp("^[a-zA-Z0-9-_ ]*$");
            if(!sshRegex.test(form.sshName)) {
                this.setState({ sshKeyRegex: true });
            } else {
                this.setState({ sshKeyRegex: false });
            }
        } else {
            this.setState({ sshKeyRegex: false });
        }

        this.setState({ instanceForm: form, sshEmpty: false, sshPublickeyEmpty: false, sshPublickeyError: false, sshNameError: false, userDataErrorMessg: false }, () => this.isDisabled());
    };

    addUnit() {
        if(this.state.isYearly && this.state.isCloud) {
            return;
        }
        if(this.state.isCloud) {
            let form = this.state.instanceForm;
            form.unit = ++form.unit;
            if(this.state.isScpu && form.unit > 25) {
                form.unit = 25;
            }
            else if(!this.state.isScpu && form.unit > 10) {
                form.unit = 10;
            }
            this.setUnitName(form.unit);
            this.setState({ instanceForm: form, unitErrorMessg: '' });
        }
        else {
            let form = this.state.instanceForm;
            form.unit = ++form.unit;
            if(this.state.unitsAvail != -1 && form.unit > this.state.unitsAvail) {
                form.unit = this.state.unitsAvail;
            }
            this.setUnitName(form.unit);
            this.setState({ instanceForm: form, unitErrorMessg: '' });
        }


    }

    removeUnit() {
        if(this.state.isYearly && this.state.isCloud) {
            return;
        }
        let unit = this.state.instanceForm.unit;
        if(unit === undefined || unit === '' || unit === 1) {
            return;
        }
        let form = this.state.instanceForm;
        form.unit = --form.unit;
        this.setUnitName(form.unit);
        this.setState({ instanceForm: form, unitErrorMessg: '' });
    }
    addSshkey = (event) => {
        let form = this.state.instanceForm;
        let error = false;
        //var sshRegex = new RegExp("^([a-zA-Z])[a-zA-Z0-9-_ ]*$");
        var sshRegex = new RegExp("^[a-zA-Z0-9-_ ]*$");
        if(form.sshName === undefined || form.sshName === '') {
            this.setState({ sshEmpty: true });
            document.getElementById('keyNameInp').focus();
            error = true;
            return;
        } else {
            this.setState({ sshEmpty: false });
        }
        if(!sshRegex.test(form.sshName)) {
            this.setState({
                sshKeyRegex: true
            });
            document.getElementById('keyNameInp').focus();
            error = true;
            return;
        } else if(!isKeyValid(form.sshPublickey.trim())) {
            this.setState({
                sshPublickeyError: true
            });
            document.getElementById('keyInp').focus();
            error = true;
            return;
        } else {
            this.setState({ sshKeyRegex: false });
        }
        if(form.sshPublickey === undefined || form.sshPublickey === '') {
            this.setState({ sshPublickeyEmpty: true });
            document.getElementById('keyInp').focus();
            error = true;
            return;
        } else {
            this.setState({ sshPublickeyEmpty: false });
        }
        if(!error) {
            this.setState({ isAction: true });
            const data = {
                name: form.sshName.trim(),
                public_key: form.sshPublickey.trim(),
            };

            let compRegionUrl = this.getComputeRegionUrl(this.state.instanceForm.region);
            SshkeyService.addSshKey(data.name, data.public_key).then(res => {
                if(res && res.data && res.data.body !== null) {
                    if(res.data.body.hasOwnProperty("secret_ref")) {
                        let secret = res.data.body.secret_ref;
                        this.setSshKeySelectByRegion(compRegionUrl, secret.split("/").pop());
                        this.setState({ message: "SSH key " + form.sshName + " has been added", enablesshkey: false, isAction: false, sshKeyRegex: false, sshEmpty: false, sshPublickeyEmpty: false, sshPublickeyError: false, sshNameError: false }, () => this.isDisabled());
                        $('.main_slider').removeClass('active');
                        $('body').removeClass('no_scroll');
                        const sshbody = {
                            "userId": localStorage.getItem("userId"),
                            "name": "SSH key " + data.name + " has been added successfully",
                            "operation": "SSH Key Added",
                            "region": ""
                        };
                        AuditLog.storeAuditLogs(sshbody, "instance").then((resp) => {
                            if(resp === false);
                        });
                    }
                    if(res.data.body.badRequest) {
                        this.setState({ sshPublickeyError: true, isAction: false });
                        document.getElementById('keyInp').focus();
                    }
                    if(res.data.body.conflictingRequest) {
                        this.setState({ sshNameError: true, isAction: false });
                        document.getElementById('keyNameInp').focus();
                    }
                    return;
                }
                this.setState({ message: "Failed to add SSH key", msgType: "error", error: true, isAction: false, errorMessg: res.text });
            });
        }

    };

    cancel = (event) => {
        $('.main_slider').removeClass('active');
        $('body').removeClass('no_scroll');
    };


    onRegionChange = (value) => {
        var url = new URL(window.location.href);
        var appstackName = url.searchParams.get("appstack");
        if(appstackName === undefined || appstackName === null) {
            $('.create_module .distribute_sec .distribution_box').removeClass('active');
        }
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let val = value;

        this.setState({ isAction: true, sshErrorMessg: '' });

        let imageRegionUrl = this.getImageRegionUrl(val);
        let ComputeRegionUrl = this.getComputeRegionUrl(val);
        let locInstanceForm = this.state.instanceForm;
        locInstanceForm.region = val;
        locInstanceForm.unitName = '';
        locInstanceForm.ram = '';
        locInstanceForm.distName = '';
        locInstanceForm.distrVersionName = '';
        locInstanceForm.flavorRefId = '';
        locInstanceForm.imageRefId = '';
        locInstanceForm.distName = '';
        locInstanceForm.monthlyRate = '0';
        locInstanceForm.unit = 1;

        this.setImageDetailsByRegion(imageRegionUrl);
        this.setFlavorDetailsByRegion(val);
        this.setSshKeyByRegion("onChange");
        this.getBmFlavours(val);
        this.checkRegionForSpeedLink(val);
        this.setState({
            selectedRegionUrl: ComputeRegionUrl, instanceForm: locInstanceForm, isScpu: true, isYearly: false,
            bmrPrice: 0, isPrepaidMonthly: true,
            bmrFlavorRefId: "",
            bmrLimit: 1,
            bmrQuery: "",
            isRequestSubmitted: true
        });
        this.uncheckCheckBox();
    };

    uncheckCheckBox() {
        $(".checkremo").each(function () {
            $(this).prop("checked", false);
        });

        //for()
    }


    componentDidMount() {
        document.title = "IDrive® Compute | Create Instance";
        window.scrollTo(0, 0);
        this.setDiscount();
        this.setBmDiscount();
        this.checkValidEmail();

        //this.skipLimitUser()
        document.addEventListener("keyup", this.escfunction, false);
        $("body").removeClass("popup_no_scroll");
        this.getAllKBInfo();
    }

    getAllKBInfo() {
        instanceService.getAllKbInfo().then(resp => {
            if(resp && Array.isArray(resp)) {
                this.setState({ kbArticles: resp });
            }
        });
    }

    skipLimitUser() {
        userService.isSkipLimitUser().then(resp => {
            this.setState({ skipLimit: resp });
        });
    }

    setDiscount() {
        FlavorService.getDiscounts().then(resp => {
            if(Array.isArray(resp)) {

                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({
                            nonBmDiscCode: ob.code, nonBmDiscPerce: ob.discount, nonBmDiscVal: 100 / ob.discount, discCode: ob.code, discPerce: ob.discount, discVal: 100 / ob.discount
                        });
                    }
                }
            }
        });

        FlavorService.getMonthlyDiscounts('month').then(resp => {
            if(Array.isArray(resp)) {
                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({ promocode: ob.code, discMonPerce: ob.discount, discMonVal: 100 / ob.discount });
                    }
                }
            }
        });
    }
    setBmDiscount() {
        FlavorService.getBmDiscounts().then(resp => {
            if(Array.isArray(resp)) {
                for(let i = 0; i < resp.length; i++) {

                    if(resp[i].code_type == "baremetal") {
                        let ob = resp[i];
                        this.setState({ bmDiscCode: ob.code, bmDiscPerce: ob.discount, bmDiscVal: 100 / ob.discount });
                    }
                }

            }
        });
    }
    checkValidEmail = () => {
        let email = localStorage.getItem("email");
        this.setState({ isAction: true });
        axiosInstance.post(API_HOST + "/user/domainCheck/" + email, {}, axiosRequestWithAuth)
            .then(resp => {
                let res = resp.data;
                this.setState({
                    isBlocked: res === "NOT_BLOCKED" ? false : true
                });
                this.checkForSubscription();
            })
            .catch(error => {
                this.setState({ isAction: false });
            });
    };

    checkForSubscription = () => {
        this.setState({ isAction: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isUserSubscribed: true
                });
                let form = this.state.instanceForm;
                form.password = getRandomPassword();

                this.setState({ instanceForm: form });
                this.loadRegionUserNotSubscribed();
            }
            else {
                let form = this.state.instanceForm;
                form.password = getRandomPassword();
                this.setState({ isAction: true, instanceForm: form });
                this.loadRegions();

            }

        });
    };
    loadRegionUserNotSubscribed() {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            if(resp && resp.length > 0) {

                let form = this.state.instanceForm;
                let elem = resp[0];
                form.region = elem.id;
                form.regionValue = elem.name;
                form.regionCapcity = elem.capacity;
                this.setFlavorDetailsByRegion(elem.id);
                this.getBmFlavours(elem.id);
                this.checkRegionForSpeedLink(elem.id);
                //let sortedFlavours = this.sortPlanByAmount(Flavours)
                let appStackFormat = this.formatAppStack(AppImages);
                let uniqueDistImages = getUnique(Distribution, 'distribution');
                uniqueDistImages.sort(function (a, b) {
                    if(a.distribution.toLowerCase() < b.distribution.toLowerCase()) { return -1; }
                    if(a.distribution.toLowerCase() > b.distribution.toLowerCase()) { return 1; }
                    return 0;
                });
                this.setState({
                    instancePlans: Flavours,
                    //instanceFilterPlans: sortedFlavours.filter(filt => filt.type === 'SCPU'),
                    //bmrFlavourPlans: sortedFlavours.filter(filt => filt.type === 'BM'),
                    regions: resp,
                    distributionImages: Distribution,
                    uniqueDistImages: uniqueDistImages,
                    bareMetalImagesUnique: getUnique(Distribution, 'distribution'),
                    regions: resp,
                    isregionselected: true,
                    countryName: elem.countryName,
                    instanceForm: form,
                    applicationStack: appStackFormat,
                    showBmrBox: true
                });

            } else {
                this.setState({ isAction: false });
            }

        });
    }

    formatAppStack(data) {
        let applicationStack = [];
        data.forEach(flavor => {
            let flavorName = flavor.name.split("-");
            flavor.distribution = flavorName[0];
            flavor.version = flavorName[1];
            flavor.instructionSet = flavorName[2];
            if(flavor.status !== 'active') return;
            flavor.tags.forEach(key => {
                try {
                    var rawName = flavor.name.split('-');
                    let checkRawName = rawName[0];
                    flavor.rawName = rawName[0];
                    if(checkRawName !== undefined && rawName[0].includes(':')) {
                        var splitName = checkRawName.split(':');
                        flavor.rawName = splitName[0];
                        flavor.nameDesc = splitName[1];
                    }
                    flavor.os = rawName[1];
                    flavor.version = rawName[2];
                }
                catch(err) {
                    console.log(err);
                }
            });
            applicationStack.push(flavor);
        });
        return applicationStack;
    }


    setRegionSelectState() {
        this.setState({ dropRegion: '', isregionselected: true });
    }

    setImageRegionDetails(selectedRegion) {
        instanceService.getRegionListByType('image').then(data1 => {
            let data = data1;
            if(data && data.length > 0) {
                let val = {};
                if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
                    val = data.find(item => item.region === this.props.location.state.regionName);
                    data = [];
                    data.push(val);
                    this.setFlavorDetailsByRegion(this.props.location.state.regionName);
                    this.setImageDetailsByRegion(val.url);
                    this.setComputeRegionDetails(val.region);
                } else {
                    val = data.find(item => item.region === selectedRegion);
                    this.setFlavorDetailsByRegion(val.region);
                    this.setImageDetailsByRegion(val.url);
                    this.setComputeRegionDetails(val.region);
                    this.setState({ regionList: data });
                }
            } else {
                this.setState({ isAction: false });
            }
        });
    }

    setComputeRegionDetails(regionName) {
        instanceService.getRegionListByType('compute').then(data1 => {
            let data = data1;
            this.setState({ isAction: false });
            if(data && data.length > 0) {
                let val = {};
                if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
                    val = data.find(item => item.region === this.props.location.state.regionName);
                    data = [];
                    data.push(val);
                    this.setSshKeyByRegion("onLoad");
                    this.getBmFlavours(this.props.location.state.regionName);

                    this.setState({ selectedRegionUrl: val.url, computeRegionList: data, dropRegion: this.props.location.state.regionName });
                } else {
                    val = data.find(item => item.region === regionName);
                    this.setSshKeyByRegion("onLoad");
                    this.getBmFlavours(regionName);

                    this.setState({ computeRegionList: data, selectedRegionUrl: val.url });
                }


            }
        });
    }

    getComputeRegionUrl(region) {
        return this.state.computeRegionList.find(elem => elem.region === region).url;
    }

    getImageRegionUrl(region) {
        return this.state.regionList.find(elem => elem.region === region).url;
    }

    setDistributionForm(form) {

    }

    setImageForm(form, newImage) {
        form.imageRefId = newImage.id;
        let imageDistName = this.getImageVersion(newImage.name);
        form.unitName = imageDistName;
        form.distName = imageDistName;
        newImage.isSelected = true;
        form.name = imageDistName;
        return form;
    }

    setApplicationForm(form) {

    }

    setImageDetailsByRegion(regionUrl) {
        let form = this.state.instanceForm;
        if(this.props.location.state && this.props.location.state.image) {
            let newImage = this.props.location.state.image;
            newImage.isSelected = true;
            form.imageRefId = newImage.id;
            let imageDistName = this.getImageVersion(newImage.name);
            form.unitName = imageDistName;
            form.distName = imageDistName;
            form.name = imageDistName;
            this.setState({ images: [newImage], instanceForm: form, distributeDisplay: 'none', selectedImage: newImage });
            $('.newDistribute_tab').removeClass('active');
            $('.newDistribute').removeClass('active');
            $('.marketPlace_tab').removeClass('active');
            $('.createdDistribute_tab').addClass('active');
            $('.createdDistribute').addClass('active');
        } else {
            instanceService.getImageDetailsByRegion(regionUrl).then(imageResp => {
                if(imageResp && imageResp.images && imageResp.distributionImages) {
                    var distrImages = imageResp.distributionImages;
                    var applicationStack = imageResp.applicationStack;
                    var images = imageResp.images.filter(item => item.status === 'active');
                    var tabManage = 'distribution';
                    var selectedImage = {};

                    //path url code starts
                    try {
                        var url = new URL(window.location.href);
                        var appstackName = url.searchParams.get("appstack");
                        if(appstackName) {
                            var ob = applicationStack.find(item => item.name === appstackName);
                            if(ob === undefined) {
                                ob = applicationStack.find(item => item.name.includes(appstackName));
                            }
                            if(ob !== undefined) {
                                ob.isSelected = true;
                                tabManage = "marketplace";
                                let imageDistName = ob.rawName + '-' + ob.os + '-' + ob.version.split(' ').join('');
                                form.unitName = imageDistName;
                                form.distName = imageDistName;
                                form.name = ob.name;
                                selectedImage = ob;
                                form.imageRefId = ob.id;
                                if(ob.rawName === 'RancherOS') {
                                    this.onAuthCentrClick('sshKey');
                                    this.setState({ config_drive: true, isPasswdDisabled: true, isRancher: true });
                                }
                                this.onAppTabTabClick();
                            }
                        }
                    } catch(error) {
                        console.log(error);
                    }
                    //path url code ends

                    if(this.props.location.state && this.props.location.state.instanceOb) {
                        var imageId = this.props.location.state.instanceOb.image.id;
                        distrImages = this.getSelectedDistr(distrImages, imageId);
                        let ob = distrImages.find(item => item.id === imageId);
                        form.imageRefId = imageId;
                        if(ob !== undefined) {
                            form.distName = ob.distribution;
                            form.version = ob.version;
                            form.instSet = ob.instructionSet;
                            form.distrVersionName = ob.distribution + ob.version;
                            form.name = ob.name;
                            selectedImage = ob;
                        } else {
                            ob = images.find(item => item.id === imageId);
                            if(ob === undefined) {
                                ob = applicationStack.find(item => item.id === imageId);
                                if(ob !== undefined) {
                                    ob.isSelected = true;
                                    tabManage = "marketplace";
                                    let imageDistName = ob.rawName + '-' + ob.os + '-' + ob.version.split(' ').join('');
                                    form.unitName = imageDistName;
                                    form.distName = imageDistName;
                                    form.name = ob.name;
                                    selectedImage = ob;
                                    this.onAppTabTabClick();
                                }
                            } else {
                                tabManage = "image";
                                let imageDistName = this.getImageVersion(ob.name);
                                form.unitName = imageDistName;
                                form.distName = imageDistName;
                                form.name = imageDistName;
                                selectedImage = ob;
                                ob.isSelected = true;
                                this.onImageTabClick();
                                //this.setImageForm(form,this.props.location.state.instanceOb.image)
                            }

                        }
                    }
                    var uniqueDistImages = getUnique(distrImages, 'distribution');
                    uniqueDistImages.sort(function (a, b) {
                        if(a.distribution.toLowerCase() < b.distribution.toLowerCase()) { return -1; }
                        if(a.distribution.toLowerCase() > b.distribution.toLowerCase()) { return 1; }
                        return 0;
                    });
                    form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, this.state.instanceForm.flavorType, this.state.instanceForm.ram);
                    this.setState({
                        images: images,
                        distributionImages: distrImages,
                        uniqueDistImages: uniqueDistImages,
                        applicationStack: applicationStack,
                        bareMetalImages: imageResp.bareMetalImages,
                        bareMetalImagesUnique: getUnique(imageResp.bareMetalImages, 'distribution'),
                        tabManage: tabManage, selectedImage: selectedImage,
                        instanceForm: form
                    }, () => this.setState({ instanceForm: form }));
                }
            });
        }
    }
    getSelectedDistr(array, imageId) {
        let ob = array.find(item => item.id === imageId);
        let distName = '';
        let version = '';
        let images = [];
        if(ob !== undefined) {
            distName = ob.distribution;
            sessionStorage.distName = ob.distribution;
            ob.isImage = true;
            ob.isSelected = true;
            let instructionSet = ob.instructionSet !== undefined ? '*' + ob.instructionSet : ob.instructionSet;
            version = ob.version + instructionSet;
            ob.selectedVersion = version;
        }
        array.forEach(element => {
            if(element.distribution === distName) {
                element.isSelected = true;
                element.selectedVersion = version;
            }
            images.push(element);
        });
        return images;
    }

    setFlavorDetailsByRegion(regionName) {
        instanceService.getFlavorDetailsByRegion(regionName).then(flavors => {
            if(flavors !== undefined && Array.isArray(flavors)) {
                let sortedFlavours = this.sortPlanByAmount(flavors);
                var isYearly = false;
                var isPrepaidMonthly = true;
                var isScpu = true;
                var dcpuList = [];
                let form = this.state.instanceForm;
                let selectedFlavor = {};
                if(this.props.location.state && this.props.location.state.instanceOb) {
                    sortedFlavours.forEach(item => {
                        if(item.id === this.props.location.state.instanceOb.flavor.id) {
                            item.isSelected = true;
                            isYearly = false;
                            isScpu = item.type === 'SCPU';
                            form.ram = item.ram;
                            form.processor = item.processor;
                            form.storage = item.storage;
                            form.flavorRefId = item.id;
                            form.flavorType = item.type;
                            form.monthlyRate = item.monthlyRate;
                            selectedFlavor = item;
                            item.isCpuOptimised = item.type === 'COF';
                            item.isMemoryOptimised = item.type === 'MOF';
                        }
                    });
                    if(!isScpu) {
                        dcpuList = sortedFlavours.filter(filt => filt.type !== 'SCPU');
                    }
                }
                this.setState({
                    instancePlans: flavors,
                    instanceFilterPlans: sortedFlavours.filter(filt => filt.type === 'SCPU'),
                    isYearly: isYearly,
                    isPrepaidMonthly: isPrepaidMonthly,
                    isScpu: isScpu,
                    dcpuList: dcpuList,
                    instanceForm: form,
                    selectedFlavor: selectedFlavor
                });
            }
        });
    }

    sortPlanByAmount(items) {
        if(items.length > 0) {
            items.sort(function (a, b) {
                return a.monthlyRate - b.monthlyRate;
            });
        }
        return items;
    }

    setSshKeyByRegion(param) {
        if(param === "onLoad") {
            SshkeyService.getSshKeyList("create").then(res => {
                if(res === false) {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler("Error while fetching SSH keys", "error");
                    return;
                }
                res.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
                this.setState({
                    sshKeys: res,
                    isAction: false
                });


            });
        }
        else {
            setTimeout(() => {
                this.setState({
                    isAction: false
                });
            }, 2000);

        }

        /*instanceService.getSshKeyByRegion(regionUrl).then(list => {
            this.setState({sshKeys: list,isAction: false }); 
        })*/
    }

    setSshKeySelectByRegion(regionUrl, keyName) {
        SshkeyService.getSshKeyList("create").then(res => {
            if(res === false) {
                this.props.bgShadowHandler(false);
                this.props.msgHandler("Error while fetching SSH keys", "error");
                return;
            }

            let ob = res.find(item => item.secretref === keyName);
            let sshKeysLoc = this.state.sshKeys;
            let uuidList = this.state.uuidList;
            ob.isSelected = true;
            sshKeysLoc.push(ob);
            uuidList.push(ob);
            sshKeysLoc.sort(function (a, b) {
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
            if(res.length === uuidList.length) {
                document.getElementById("selectAll").checked = true;
            }
            this.setState({ sshKeys: sshKeysLoc, isAction: false, uuidList: uuidList }, () => this.isDisabled());

        });
        /* instanceService.getSshKeyByRegion(regionUrl).then(list => {
             let ob = list.find(item=>item.name===keyName)
             let sshKeysLoc = this.state.sshKeys;
             let uuidList = this.state.uuidList
             ob.isSelected = true
             sshKeysLoc.push(ob)
             uuidList.push(ob)
             this.setState({sshKeys: sshKeysLoc,isAction: false ,uuidList:uuidList}); 
         })*/
    }
    onBareClickMenu = (event, distribution) => {
        if(event.target.className === 'custom_radio' || (event.target.className === '')) {
            return;
        }
        $(event.currentTarget).closest('.distribution_box').find('.distribute_option_dropdown').addClass('active');
        let menuDistImages = this.state.bareMetalImages.filter(item => item.distribution === distribution);
        if(menuDistImages[0] && menuDistImages[0].version && menuDistImages[0].version.includes('LTS')) {
            menuDistImages.sort(function (a, b) {
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                return 0;
            });
        } else {
            menuDistImages.sort(function (a, b) {
                return b.version - a.version;
            });
        }
        let uniqueDistImages = this.state.bareMetalImagesUnique;
        let instanceForm = this.state.instanceForm;
        // if(distribution !== this.state.instanceForm.distName) {
        //     for(var i = 0; i < uniqueDistImages.length; i++) {
        //         uniqueDistImages[i].selectedVersion = undefined;
        //     }
        //     instanceForm.distName = '';
        //     instanceForm.name = '';
        //     instanceForm.imageRefId = '';
        //     if(!this.state.isUnitNameFocused) {
        //         instanceForm.unitName = this.constructUnitName('', '', "BM", this.state.instanceForm.ram);
        //     }
        //     $('.dropdown_component .custom_radio').removeClass('active');
        // }
        this.isDisabled();

        for(var i = 0; i < uniqueDistImages.length; i++) {
            if(uniqueDistImages[i].distribution === distribution) uniqueDistImages[i].distImagesMenu = menuDistImages;

        }

        this.setState({ bareMetalImagesUnique: uniqueDistImages, instanceForm: instanceForm });
    };

    onMenuIconClick = (event, distribution) => {
        if(this.state.isBmr) {
            this.onBareClickMenu(event, distribution);
            return;
        }
        if(event.target.className === 'custom_radio' || (event.target.className === '')) {
            return;
        }
        $(event.currentTarget).closest('.distribution_box').find('.distribute_option_dropdown').addClass('active');
        let menuDistImages = this.state.distributionImages.filter(item => item.distribution === distribution);
        if(menuDistImages[0] && menuDistImages[0].distribution === 'Debian') {
            menuDistImages.sort(function (a, b) {
                return b.version - a.version;
            });
        } else {
            menuDistImages.sort(function (a, b) {
                if(a.version.toLowerCase() > b.version.toLowerCase()) { return -1; }
                if(a.version.toLowerCase() < b.version.toLowerCase()) { return 1; }
                return 0;
            });
        }
        let uniqueDistImages = this.state.uniqueDistImages;
        let instanceForm = this.state.instanceForm;
        // if(distribution !== this.state.instanceForm.distName) {
        //     for(var i = 0; i < uniqueDistImages.length; i++) {
        //         uniqueDistImages[i].selectedVersion = undefined;
        //     }
        //     instanceForm.distName = '';
        //     instanceForm.name = '';
        //     instanceForm.imageRefId = '';
        //     if(!this.state.isUnitNameFocused) {
        //         instanceForm.unitName = this.constructUnitName('', '', this.state.instanceForm.flavorType, this.state.instanceForm.ram);
        //     }
        //     $('.dropdown_component .custom_radio').removeClass('active');
        //     if(this.props.location.state && this.props.location.state.instanceOb) {
        //         menuDistImages.forEach(elem => {
        //             if(elem.id === this.props.location.state.instanceOb.image.id) {
        //                 elem.isImage = false;
        //             }
        //         });
        //     }
        // }
        this.isDisabled();
        for(var i = 0; i < uniqueDistImages.length; i++) {
            if(uniqueDistImages[i].distribution === distribution) uniqueDistImages[i].distImagesMenu = menuDistImages;

        }
        this.setState({ uniqueDistImages: uniqueDistImages, instanceForm: instanceForm, config_drive: false, isPasswdDisabled: false, isRancher: false });
    };

    onDistrTabClick() {
        $('.createdDistribute_tab').removeClass('active');
        $('.createdDistribute').removeClass('active');
        $('.marketPlace_tab').removeClass('active');
        $('.marketPlaceCtnr').removeClass('active');
        $('.newDistribute_tab').addClass('active');
        $('.newDistribute').addClass('active');
    }

    onImageTabClick() {
        $('.newDistribute_tab').removeClass('active');
        $('.newDistribute').removeClass('active');
        $('.marketPlace_tab').removeClass('active');
        $('.marketPlaceCtnr').removeClass('active');
        $('.createdDistribute_tab').addClass('active');
        $('.createdDistribute').addClass('active');
    }

    onAppTabTabClick() {
        $('.newDistribute_tab').removeClass('active');
        $('.newDistribute').removeClass('active');
        $('.createdDistribute_tab').removeClass('active');
        $('.createdDistribute').removeClass('active');
        $('.marketPlace_tab').addClass('active');
        $('.marketPlaceCtnr').addClass('active');
    }

    distributionBoxClick = (event, distribution) => {
        if(event.target.className === 'custom_radio' || (event.target.className === '')) {
            return;
        }
        //$('.create_module .distribute_sec .distribution_box').removeClass('active');
        //$(event.currentTarget).toggleClass('active');
        this.onMenuIconClick(event, distribution);
    };

    planBoxClick = (event, param) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        $(event.currentTarget).toggleClass('active');
        let form = this.state.instanceForm;
        form.ram = param.ram;
        form.processor = param.processor;
        form.storage = param.storage;
        form.flavorRefId = param.id;
        form.flavorType = param.type;
        form.monthlyRate = param.monthlyRate;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, param.type, param.ram);
        }
        this.isDisabled();
        this.setState({ instanceForm: form, errorMessg: '', selectedFlavor: param, planErrorMessg: '' });
    };

    planRadioClick = (event, type) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let form = this.state.instanceForm;
        form.unit = 1;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        this.setState({ isScpu: true, isYearly: false, isPrepaidMonthly: true });
    };
    onDscpuPlanClick = (event, type) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let plans = this.state.instancePlans.filter(item => item.type !== 'SCPU');
        let form = this.state.instanceForm;
        form.unit = 1;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        this.setState({ dcpuList: plans, isScpu: false, isYearly: false, isPrepaidMonthly: true });
    };
    bmDistVersionSelect = (event, param, distributionImage) => {
        $('.dropdown_component .custom_radio').removeClass('active');
        if(param.version === undefined) {
            param.version = '';
        }
        if(param.instructionSet === undefined) {
            param.instructionSet = '';
        }
        let form = this.state.instanceForm;
        form.name = param.name;
        form.distName = param.distribution;
        form.version = param.version;
        form.instSet = param.instructionSet;
        form.imageRefId = param.id;
        form.distrVersionName = param.distribution + param.version;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(param.distribution, param.version, "BM", this.state.instanceForm.ram);
        }
        let instructionSet = param.instructionSet !== undefined ? '*' + param.instructionSet : param.instructionSet;
        let version = param.version + instructionSet;
        let uniqueDistImages = this.state.bareMetalImagesUnique;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            let elem = uniqueDistImages[i];
            if(distributionImage.distribution === elem.distribution) {
                elem.selectedVersion = version;
            } else {
                elem.selectedVersion = undefined;
            }
        }
        $(event.currentTarget).closest('.custom_radio').addClass('active');

        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        $(event.currentTarget).closest('.distribution_box').toggleClass('active');

        $('.distribute_option_dropdown').removeClass('active');
        this.isDisabled();
        this.setState({ instanceForm: form, errorMessg: '', selectedImage: param, bareMetalImagesUnique: uniqueDistImages, distErrorMessg: '' });
        event.stopPropagation();
    };
    distVersionSelect = (event, param, distributionImage) => {
        if(this.state.isBmr) {
            this.bmDistVersionSelect(event, param, distributionImage);
            return;
        }
        $('.dropdown_component .custom_radio').removeClass('active');
        if(param.version === undefined) {
            param.version = '';
        }
        if(param.instructionSet === undefined) {
            param.instructionSet = '';
        }
        let form = this.state.instanceForm;
        form.name = param.name;
        form.distName = param.distribution;
        form.version = param.version;
        form.instSet = param.instructionSet;
        form.imageRefId = param.id;
        form.distrVersionName = param.distribution + param.version;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(param.distribution, param.version, this.state.instanceForm.flavorType, this.state.instanceForm.ram);
        }
        let instructionSet = param.instructionSet !== undefined ? '*' + param.instructionSet : param.instructionSet;
        let version = param.version + instructionSet;
        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {

            let elem = uniqueDistImages[i];
            if(distributionImage.distribution === elem.distribution) {
                elem.selectedVersion = version;
            } else {
                elem.selectedVersion = undefined;
            }
        }
        $(event.currentTarget).closest('.custom_radio').addClass('active');

        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        $(event.currentTarget).closest('.distribution_box').toggleClass('active');

        $('.distribute_option_dropdown').removeClass('active');
        this.isDisabled();
        this.setState({ instanceForm: form, errorMessg: '', selectedImage: param, uniqueDistImages: uniqueDistImages, distErrorMessg: '' });
        event.stopPropagation();
    };

    closeBlockUserPopup = () => {
        $(".blockUser_popup").removeClass('active');
        $("body").removeClass("no_scroll");
    };

    handlesubmit = (event) => {
        event.preventDefault();
        let isSshKey = this.state.isSshKey;
        if(this.state.isBlocked) {
            this.setState({
                userBlockType: "instance"
            });
            $(".blockUser_popup").addClass('active');
            $("body").addClass("no_scroll");
            return;
        }
        if(!this.validate()) {
            return;
        }
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
            return;
        }

        let form = this.state.instanceForm;
        form.unitName = this.state.instanceForm.unitName.trim();
        this.setState({ isAction: true, instanceForm: form });
        let requestBody = {
            server: {
                flavorRef: this.state.instanceForm.flavorRefId,
                imageRef: this.state.instanceForm.imageRefId,
                key_name: this.state.keyName,
                max_count: this.state.instanceForm.unit,
                min_count: 1,
                name: form.unitName,
                availability_zone: this.state.availabilityZone,
                config_drive: this.state.config_drive
            },
            name: getDistUserName(this.state.instanceForm.distName.toLowerCase()),
            sshAuthorizedKeys: [],
            uuidList: isSshKey ? this.getSShList(this.state.uuidList) : [],
            passwords: isSshKey ? null : this.state.instanceForm.password,
            backupEnabled: this.state.instanceForm.isBackupEnabled,
            privateIp: this.state.instanceForm.privateIp,
            userData: form.isUserData ? this.state.instanceForm.userData : '',
            regionName: this.state.instanceForm.region,
            distrName: this.state.instanceForm.distrVersionName,
            rootLogin: this.state.instanceForm.isLoginData,
            yearly: this.state.isYearly,
            discCode: this.state.isPrepaidMonthly ? this.state.promocode : this.state.discCode,
            isCloud: this.state.isCloud,
            resourceClass: this.state.resourceClass,
            distributionName: this.state.instanceForm.name,
            processor: this.state.instanceForm.processor,
            storage: this.state.instanceForm.storage + ' NVMe Storage',
            bandwidth: formatBandwidthBytes(this.state.selectedFlavor.bandwidth, this.state.isYearly),
            ram: this.state.instanceForm.ram + ' RAM',
            cputype: this.state.isScpu ? 'Shared' : 'Dedicated',
            isRancher: this.state.isRancher,
            prepaidMonthly: this.state.isPrepaidMonthly
        };
        let regionUrl = this.state.selectedRegionUrl;
        if(regionUrl === '') {
            regionUrl = this.getComputeRegionUrl(this.state.instanceForm.region);
        }
        if(regionUrl & this.state.selectedFlavor.region && !regionUrl.toLowerCase().includes(this.state.selectedFlavor.region.toLowerCase())) {
            return;
        }
        instanceService.createServer(JSON.stringify(requestBody), regionUrl).then(resp => {
            try {
                if(resp && resp === "BLOCKED") {
                    this.setState({
                        userBlockType: "instance",
                        isAction: false
                    });
                    $(".blockUser_popup").addClass('active');
                    $("body").addClass("no_scroll");
                    return;
                }
                if(resp && (resp.server || resp.reservation_id)) {
                    let plan_type = this.state.isPrepaidMonthly ? 'Prepaid monthly ' : this.state.isYearly ? 'Prepaid yearly ' : 'Postpaid monthly ';

                    let instanceCreateName = plan_type + "instance " + requestBody.server.name + " has been created";
                    if(this.state.instanceForm.isBackupEnabled) {
                        localStorage.setItem("_banner_show", "hide");
                        instanceCreateName = plan_type + "Instance " + requestBody.server.name + " has been created with backup enabled";
                    }
                    if(this.state.instanceForm.privateIp) {
                        instanceCreateName = plan_type + "instance " + requestBody.server.name + " has been created with private IP";
                    }
                    if(this.state.instanceForm.isBackupEnabled && this.state.instanceForm.privateIp) {
                        instanceCreateName = plan_type + "instance " + requestBody.server.name + " has been created with backup enabled and private IP";
                    }
                    if(!this.state.instanceForm.isBackupEnabled) {
                        if(localStorage.getItem("_cmplt_banner_show") !== "hide") {
                            localStorage.setItem("_banner_show", "show");
                        }

                    }
                    const requestBdy = {
                        "userId": localStorage.getItem("userId"),
                        "name": instanceCreateName,
                        "operation": requestBody.server.max_count > 1 ? "Instances Created (" + requestBody.server.max_count + ")" : "Instance Created",
                        "region": this.state.instanceForm.region
                    };
                    AuditLog.storeAuditLogs(requestBdy, "instance").then((resp) => {
                        if(resp === false);
                    });
                    if(this.state.isYearly && this.state.instanceForm.unit > 1) {
                        let timewait = (this.state.instanceForm.unit * 1000) / 2;
                        setTimeout(() => {
                            this.navigateToIndex();
                        }, timewait);
                    } else {
                        this.navigateToIndex();
                    }
                    return;
                }
                if(resp && resp.forbidden) {
                    this.setState({ forbiddenErrorMessg: getMessage(resp.forbidden.message), isAction: false });
                    window.scrollTo(0, 0);
                    return;
                }
                if(resp && resp.message.includes("403")) {
                    this.setState({ message: 'Forbidden Access - Failed to create the Instance', msgType: 'error', isAction: false });
                    window.scrollTo(0, 0);
                    return;
                }
                if(resp && resp.badRequest === undefined) {
                    this.setState({ message: resp.message, msgType: 'error', isAction: false });
                    return;
                }
                if(resp === undefined || resp.badRequest === undefined) {
                    this.setState({ message: 'Internal network issue. Please try again.', msgType: 'error', isAction: false });
                    return;
                }
                this.setState({ message: 'Failed to create the Instance', msgType: 'error', isAction: false });
            } catch(e) {
                if(resp && (typeof resp === 'string' || resp instanceof String) && resp.includes('card details')) {
                    this.setState({ message: resp, msgType: 'error', isAction: false });
                    return;
                }
                this.setState({ message: 'Failed to create the Instance', msgType: 'error', isAction: false });
                return;
            }
        });
    };

    validateServer(reqBody) {
        instanceService.validateServer(reqBody).then(resp => {
            if(resp !== undefined && resp !== '') {
                window.scrollTo(0, 0);
                this.setState({ forbiddenErrorMessg: getMessage(resp), msgType: 'error', isAction: false });
            } else {
                this.navigateToIndex();
            }
        });
    }
    constructUnitName(distName, version, flavorType, ram) {
        if(this.state.isUnitNameFocused) {
            return;
        }
        if(version) {
            version = version.replace('.', '-');
        } else {
            version = '';
        }
        if(distName) {
            distName = distName.replace('.', '-');
        }
        let newName = distName + version + '-' + flavorType + '-' + ram + '-' + this.state.instanceForm.region;
        if(this.state.instanceForm.unit === 1) {
            newName = newName + '-1';
        }
        // console.log("name" + newName)
        if(newName === undefined) {
            return newName;
        }
        try {
            if(newName.includes('_')) newName = newName.split('_').join('-');
            if(newName.includes('.')) newName = newName.split('.').join('-');
            if(newName.includes('&')) newName = newName.split('&').join('-');
        } catch(er) {
            console.log('name err' + er);
        }
        return newName.split(' ').join('');
    }
    getSShList(list) {
        let newList = [];
        list.forEach(item => {
            newList.push(item.secretref);
        });
        return newList;
    }
    isDisabled() {
        //if(this.state.isScpu===false || this.state.instanceForm.imageRefId==='' || this.state.instanceForm.flavorRefId===''){
        if(this.state.instanceForm.imageRefId === '' || this.state.instanceForm.flavorRefId === '' || !this.checkSshPass()) {
            this.setState({ isCreateDisabled: true });
            return;
        }
        this.setState({ isCreateDisabled: false });
    }

    checkSshPass() {
        if(this.state.isSshKey) {
            if(this.state.uuidList === undefined || this.state.uuidList.length === 0) {
                if(this.state.sshKeys.length <= 0) {
                    return false;
                }
                else {
                    return false;
                }

            }
        } else {
            if(this.state.instanceForm.password === undefined || this.state.instanceForm.password === '') {
                return false;
            }
        }
        return true;
    }
    validate() {
        let isSshKey = this.state.isSshKey;
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");

        // if(!this.state.isScpu){
        //     this.setState({errorMessg:'You cannot create instance using Dedicated cpu flavour'});
        //     window.scrollTo(0, 0);
        //     return false
        // }
        if(this.state.instanceForm.region === '') {
            this.setState({ regionErrorMsg: 'Please select a region' });
            window.scrollTo(0, 0);
            return false;
        }
        if(this.state.instanceForm.imageRefId === '') {
            this.setState({ distErrorMessg: 'Please choose a required distribution version/image.' });
            window.scrollTo(0, 0);
            return false;
        }
        if(this.state.instanceForm.flavorRefId === '') {
            document.getElementById('distrSection').scrollIntoView(true);
            return false;
        }
        let flavorSize = parseInt(this.state.selectedFlavor.storage.replace('GB', ''));
        if(this.state.selectedImage.min_disk > 0 && this.state.selectedImage.min_disk > flavorSize) {
            this.setState({ planErrorMessg: 'Select a plan with disk storage equal or greater than the minimum disk storage required for the selected image.' });
            document.getElementById("planSectionCloud").scrollIntoView(true);
            return false;
        }
        let ramSize = parseInt(this.state.selectedFlavor.ram.replace('GB', ''));
        if(this.state.selectedImage.tags && this.state.selectedImage.tags[0] === 'application_stack' && this.state.selectedImage.distribution === 'GitLab' && ramSize < 4) {
            document.getElementById('planSectionCloud').scrollIntoView(true);
            this.setState({ planErrorMessg: 'Select a plan with minimum ram size of 4 GB' });
            return false;
        }
        if(isSshKey) {
            if(this.state.uuidList === undefined || this.state.uuidList.length === 0) {
                if(this.state.sshKeys.length <= 0) {
                    this.setState({ sshErrorMessg: 'Create at least one ssh key' });
                    document.getElementById('authSec').scrollIntoView(true);
                    return false;
                }
                else {
                    this.setState({ sshErrorMessg: 'Select at least one ssh key' });
                    document.getElementById('authSec').scrollIntoView(true);
                    return false;
                }

            }
        } else {
            if(this.state.instanceForm.password === undefined || this.state.instanceForm.password === '') {
                this.setState({ rootErrorMessg: 'Password should not be blank' });
                document.getElementById('password').focus();
                return false;
            }
            if(this.state.psswdStrength !== 'Strong') {
                document.getElementById('password').focus();
                //this.setState({rootErrorMessg:'The root password should be strong.'});
                return false;
            }
        }
        if(this.state.instanceForm.unit === undefined || this.state.instanceForm.unit === '') {
            document.getElementById('user_data_sec').scrollIntoView(true);
            document.getElementById('unitbox').focus();
            this.setState({ unitErrorMessg: 'Minimum 1 unit is required.' });
            return false;
        }
        if(this.state.instanceForm.unitName === undefined || this.state.instanceForm.unitName.trim() === '') {
            document.getElementById('user_data_sec').scrollIntoView(true);
            document.getElementById('unitName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name is required.' });
            return false;
        }
        if(!nameRegex.test(this.state.instanceForm.unitName)) {
            document.getElementById('user_data_sec').scrollIntoView(true);
            document.getElementById('unitName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            return false;
        }
        if(!this.state.isUserSubscribed) {
            if(!this.state.skipLimit && !isCountLessthanThreshold(this.state.instanceForm.region, this.state.instanceForm.unit)) {
                this.setState({ maxInstErrorMessg: true });
                window.scrollTo(0, 0);
                return false;
            }
        }

        if(this.state.instanceForm.isUserData && this.state.instanceForm.userData.length > 0) {
            if(this.state.instanceForm.userData.toLowerCase().trim() === "cloning") return false;
            try {
                jsyaml.load(this.state.instanceForm.userData, 'utf8');
            } catch(e) {
                document.getElementById('authSection').scrollIntoView(true);
                document.getElementById('userdatafield').focus();
                this.setState({ userDataErrorMessg: true });
                // console.log(e);
                return false;
            }
        }
        this.setState({ errorMessg: '' });
        return true;
    }

    bmImageClick = (event, elem) => {
        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        let form = this.state.instanceForm;
        let imageList = this.state.images;
        imageList.forEach(item => {
            item.isSelected = false;
        });
        elem.isSelected = true;
        form.imageRefId = elem.id;
        let imageDistName = this.getImageVersion(elem.name);
        if(!this.state.isUnitNameFocused) {

            form.unitName = this.constructUnitName(imageDistName, '', 'BM', this.state.instanceForm.ram);
        }
        form.distName = imageDistName;
        form.name = imageDistName;

        let uniqueDistImages = this.state.bareMetalImagesUnique;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
        }
        this.setState({ instanceForm: form, images: imageList, selectedImage: elem, bareMetalImagesUnique: uniqueDistImages, distErrorMessg: '' });
        $(event.currentTarget).addClass('active');
        this.isDisabled();
    };

    onImageClick = (event, elem) => {
        if(this.state.isBmr) {
            this.bmImageClick(event, elem);
            return;
        }
        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        let form = this.state.instanceForm;
        let imageList = this.state.images;
        imageList.forEach(item => {
            item.isSelected = false;
        });
        elem.isSelected = true;
        form.imageRefId = elem.id;
        let imageDistName = this.getImageVersion(elem.name);
        if(!this.state.isUnitNameFocused) {

            form.unitName = this.constructUnitName(imageDistName, '', this.state.instanceForm.flavorType, this.state.instanceForm.ram);
        }
        form.distName = imageDistName;
        form.name = imageDistName;

        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
            uniqueDistImages[i].distImagesMenu.forEach(item => { item.isImage = false; item.isSelected = false; });
        }
        this.setState({ instanceForm: form, images: imageList, selectedImage: elem, uniqueDistImages: uniqueDistImages, distErrorMessg: '', config_drive: false, isPasswdDisabled: false, isRancher: false });
        $(event.currentTarget).addClass('active');
        $('.dropdown_component .custom_radio').removeClass('active');
        this.isDisabled();
    };

    onAppImageClick = (event, elem) => {
        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        let form = this.state.instanceForm;
        form.imageRefId = elem.id;
        let imageDistName = elem.rawName + '-' + elem.os + '-' + elem.version.split(' ').join('');
        var appImgName = imageDistName.split('.').join('-');
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(appImgName, '', this.state.instanceForm.flavorType, this.state.instanceForm.ram);
        }
        form.distName = imageDistName;
        form.name = imageDistName;
        form.version = '';
        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
            uniqueDistImages[i].distImagesMenu.forEach(item => { item.isImage = false; item.isSelected = false; });
        }
        if(elem.rawName === 'RancherOS') {
            this.onAuthCentrClick('sshKey');
            this.setState({ config_drive: true, isPasswdDisabled: true, isRancher: true, uniqueDistImages: uniqueDistImages });
        } else {
            this.setState({ instanceForm: form, selectedImage: elem, distErrorMessg: '', isPasswdDisabled: false, config_drive: false, isRancher: false, uniqueDistImages: uniqueDistImages });
        }

        $(event.currentTarget).addClass('active');
        $('.dropdown_component .custom_radio').removeClass('active');
        this.isDisabled();
    };

    onsshSelect = (event, elem) => {
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        let list = this.state.uuidList;
        let sshKeysLoc = this.state.sshKeys;
        document.getElementById("selectAll").checked = false;
        if(val) {
            list.push(elem);
            elem.isSelected = true;
            sshKeysLoc.forEach(item => {
                if(item.secretref === elem.secretref) {
                    item.isSelected = true;
                }
            });
            if(list.length === this.state.sshKeys.length) {
                document.getElementById("selectAll").checked = true;
            }
            this.setState({ keyName: elem.secretref });
        } else {
            elem.isSelected = false;
            sshKeysLoc.forEach(item => {
                if(item.secretref === elem.secretref) {
                    item.isSelected = false;
                }
            });
            list = list.filter(item => item.secretref !== elem.secretref);
        }
        this.setState({ uuidList: list, sshErrorMessg: '', sshKeys: sshKeysLoc }, () => this.isDisabled());
    };
    selectAllSshKeys = (event) => {
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        let list = [];
        if(val) {

            this.state.sshKeys.map((elem, index) => {
                elem.isSelected = true;
                list.push(elem);
                this.setState({ keyName: elem.secretref });
            });
            this.setState({ uuidList: this.state.sshKeys, sshKeys: list, sshErrorMessg: "" }, () => { this.isDisabled(); });
        }
        else {
            this.state.sshKeys.map((elem, index) => {
                elem.isSelected = false;
                list.push(elem);
                this.setState({ keyName: elem.secretref });
            });
            this.setState({ uuidList: [], sshKeys: list, sshErrorMessg: "" }, () => { this.isDisabled(); });
        }

    };

    unitKeyDown(e) {
        if(e.keyCode === 39 || e.keyCode === 38) {
            this.addUnit();
        }
        if(e.keyCode === 37 || e.keyCode === 40) {
            this.removeUnit();
        }
    }
    navigateToImage() {
        this.props.history.push({
            pathname: '/images',
            state: {
                imagetype: "custom"
            }
        });
    }
    navigateToIndex() {
        this.props.history.push({
            pathname: "/index",
            state: {
                val: 'server created'
            }
        });
    }
    navigateFromBM = () => {
        this.props.history.push({
            pathname: "/index",
            state: {
                val: 'BM_SUBMIT'
            }
        });
    };
    getRegionDropdown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        if(this.props.location.state && (this.props.location.state.image || this.props.location.state.instanceOb) && this.props.location.state.regionName) {
            return;
        }
        $(".regionSelect_options").addClass("active");
        $(".region_select_container").addClass("active");
        document.getElementById('regionId').focus();
        let form = this.state.instanceForm;
        this.setState({ regionListFilter: this.state.regions, isregionselected: false, instanceForm: form, dropRegion: '' }, () => this.scrollTop());
    };
    getSelectedRegion = (event, regionOb) => {

        let id = regionOb.id; let region = regionOb.name; let countryName = regionOb.countryName.toLowerCase();
        let form = this.state.instanceForm;
        if(regionOb.status !== 1) {
            sessionStorage.inFocus = true;
            return;
        }
        sessionStorage.inFocus = false;
        $(".regionSelect_options").removeClass("active");

        $(".region_select_container").removeClass("active");
        if(id === form.region) {
            return;
        }
        if(!this.state.isUserSubscribed) {
            let item = this.state.regionList.find(elem => elem.region === id);
            form.regionUrl = item.url;
            form.region = id;
            form.regionValue = region;
            form.regionCapcity = regionOb.capacity;
            this.onRegionChange(id);

        }
        else {
            let item = this.state.regionList.find(elem => elem.region === id);
            form.region = id;
            form.regionValue = region;
            form.regionCapcity = regionOb.capacity;
            this.checkRegionForSpeedLink(id);
        }
        let zone = this.state.regions.find(elem => elem.id === id);
        if(zone.availability_zone != undefined) {

            this.setState({
                availabilityZone: zone.availability_zone
            });
        }
        this.setState({ countryName: countryName, errorMessg: '', instanceForm: form, regionErrorMsg: '', isregionselected: true, isCreateDisabled: true });
    };
    filterDropDown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        if(this.props.location.state && (this.props.location.state.image || this.props.location.state.instanceOb) && this.props.location.state.regionName) {
            return;
        }
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let lcVal = val.toLowerCase();
        let items = this.state.regions.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));
        //let form = this.state.instanceForm
        //form.region = val

        this.setState({ regionListFilter: items, selectedRegionUrl: '', dropRegion: val });
    };
    loadRegions = () => {
        let allRegion = [];
        RegionService.getAll().then((resp) => {
            allRegion = resp;
        });

        RegionService.getAllAvailabilityZone().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            if(resp && resp.length > 0) {
                let form = this.state.instanceForm;
                let val = {};
                if(this.props.location.state && (this.props.location.state.image || this.props.location.state.instanceOb) && this.props.location.state.regionName) {
                    val = resp.find(elem => elem.id === this.props.location.state.regionName);
                    form.region = this.props.location.state.regionName;
                    form.regionValue = val.name;
                    form.regionCapcity = val.capacity;
                    this.setState({ regions: resp, showBmrBox: true, Imagesshow: true, isregionselected: true, countryName: val.countryName, availabilityZone: val.availability_zone });
                    this.setImageRegionDetails(val.id);
                    this.checkRegionForSpeedLink(val.id);

                }
                else if(this.props.location.state && this.props.location.state.bmr && this.props.location.state.regionName) {
                    let locRegions = resp;
                    let elem = resp[0];
                    // if(this.state.email===REVIEWER_EMAIL) {
                    //     locRegions = resp.filter(item=>item.id===REVIEWER_REGION)
                    //     elem = locRegions[0]
                    // } else {
                    //     elem = resp[0]
                    // }

                    val = resp.find(elem => elem.id === this.props.location.state.regionName);
                    if(elem.status !== 1) {
                        elem = resp.filter(item => item.status === 1)[0];
                        //locRegions = resp;
                        if(elem === undefined) {
                            locRegions = allRegion;
                            elem = allRegion.filter(item => item.status === 1)[0];
                        }
                    }

                    form.region = this.props.location.state.regionName;
                    form.regionValue = val.name;
                    form.regionCapcity = val.capacity;
                    let bmrData = this.props.location.state.bmr;

                    this.setState({
                        regions: locRegions,
                        isregionselected: true,
                        countryName: val.countryName,
                        availabilityZone: elem.availability_zone,
                        instanceForm: form,
                        bmPlanAvail: bmrData.flavour.flavourId,
                        classType: true,
                        isPlanAvailable: true,
                        isBmr: true,
                        isCloud: false,
                        showBmrBox: true,
                        discCode: this.state.bmDiscCode,
                        discPerce: this.state.bmDiscPerce,
                        discVal: this.state.bmDiscVal
                    });
                    this.setImageRegionDetails(val.id);
                    this.checkRegionForSpeedLink(val.id);
                    $('.main').removeClass('full-width');
                    $(".distribute_sec.bare-metal-distribution").show();
                    $("#distrSectionCloud").hide();
                }
                else {
                    let locRegions = resp;
                    let elem = resp[0];
                    // if(this.state.email===REVIEWER_EMAIL) {
                    //     locRegions = resp.filter(item=>item.id===REVIEWER_REGION)
                    //     elem = locRegions[0]
                    // } else {
                    //     elem = resp[0]
                    // }

                    if(elem.status !== 1) {
                        elem = resp.filter(item => item.status === 1)[0];
                        //locRegions = resp;
                        if(elem === undefined) {
                            locRegions = allRegion;
                            elem = allRegion.filter(item => item.status === 1)[0];
                        }
                    }
                    form.region = elem.id;
                    form.regionValue = elem.name;
                    form.regionCapcity = elem.capacity;
                    this.setState({ regions: locRegions, showBmrBox: true, isregionselected: true, countryName: elem.countryName, availabilityZone: elem.availability_zone });
                    this.setImageRegionDetails(elem.id);
                    this.checkRegionForSpeedLink(elem.id);
                }
            } else {
                this.setState({ isAction: false });
            }

        });
    };
    onFocusOut = (e) => {
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if(sessionStorage.inFocus === true) {
                sessionStorage.inFocus = false;
                return;
            }
            this.setState({ dropRegion: '', isregionselected: true });
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };

    onDropArrowClick = () => {
        if($('.regionSelect_options').is('active')) {
            $(".regionSelect_options").addClass("active");
        } else {
            $(".regionSelect_options").removeClass('active');
        }
    };

    addSshClick() {
        let form = this.state.instanceForm;
        form.sshPublickey = '';
        form.sshName = '';
        this.setState({ instanceForm: form, sshErrorMessg: '', sshPublickeyEmpty: false, sshPublickeyError: false, sshEmpty: false, sshKeyRegex: false, sshNameError: false });
        $('#addshkey').addClass('active');
        setTimeout(() => {
            document.getElementById('keyNameInp').focus();
        }, 200);
    }

    onAuthCentrClick(keyName) {
        if(keyName === 'psswd') {
            if(this.state.isPasswdDisabled) return;
            $("#auth_opt00").removeClass("active");
            $("#sshkeyRadio").removeClass("active");
            $("#auth_opt01").addClass("active");
            $("#psswdRadio").addClass("active");
            $(".create_module .auth_ctnr_cont .authenticate_sec").addClass("show");
            $(".create_module .auth_ctnr_cont .sshKey_sec").removeClass("show");
            this.setState({ isSshKey: false }, () => this.isDisabled());
        } else {
            $("#psswdRadio").removeClass("active");
            $("#auth_opt01").removeClass("active");
            $("#auth_opt00").addClass("active");
            $("#sshkeyRadio").addClass("active");
            $(".create_module .auth_ctnr_cont .authenticate_sec").removeClass("show");
            $(".create_module .auth_ctnr_cont .sshKey_sec").addClass("show");
            this.setState({ isSshKey: true }, () => this.isDisabled());
        }

    }

    getImageVersion(name) {
        try {
            if(name === undefined) {
                return name;
            }
            name = name.split(' ').join('');
            if(name.includes('-')) {
                let nameArr = name.split('-');
                let firstPart = nameArr[0];
                if((firstPart.includes('open') || firstPart.includes('CentOS') || firstPart.includes('Ubuntu')) && nameArr.length >= 2) {
                    if(nameArr[1] && nameArr[1] !== '') {
                        nameArr = nameArr[0] + '-' + nameArr[1];
                    } else {
                        nameArr = firstPart;
                    }
                    return nameArr.split('.').join('-');
                } else if(firstPart.includes('Debian9') || firstPart.includes('Fedora')) {
                    return nameArr[0].split('.').join('-');
                }
            }
            if(name.length > 10) {
                return name.substring(0, 10);
            }
        } catch(err) {
            return name;
        }
        return name;
    }

    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }

    onDiffPlanClick = (planType) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let form = this.state.instanceForm;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        form.unit = 1;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        if(planType === 'yearly') {
            this.setState({ isYearly: true, isPrepaidMonthly: false, instanceForm: form });
        }
        else if(planType === "prepaidMonthly") {
            this.setState({ isYearly: false, isPrepaidMonthly: true, instanceForm: form });
        }
        else {
            this.setState({ isYearly: false, isPrepaidMonthly: false, instanceForm: form });
        }
    };
    setUnitName(unitCount) {
        if(!this.state.isUnitNameFocused) {
            let form = this.state.instanceForm;
            let name = form.unitName;
            if(name) {
                let endString = name.substring(name.length - 2, name.length);
                if(endString === '-1' && unitCount > 1) {
                    form.unitName = name.substring(0, name.length - 2);
                    this.setState({ instanceForm: form });
                }
                if(endString !== '-1' && unitCount === 1) {
                    form.unitName = name + '-1';
                    this.setState({ instanceForm: form });
                }
            }
        }
    }

    showAppSlider(name) {
        if(this.loadkbArticles(name)) return;
        if(name !== undefined) {
            let appStackLoc = appStack;
            let ob = appStackLoc.find(item => name === item.key);
            if(ob === undefined) ob = appStackLoc.find(item => name.includes(item.key));
            if(ob === undefined) return;
            let elem = ob.value;
            elem.key = ob.key;
            this.setState({ appSlider: elem }, () => {
                $('#appSlider').addClass('active');
                $('.marketApp_content_wrap').scrollTop(0);
                $('body').addClass('no_scroll');
            });
        }
    }

    loadkbArticles(name) {
        let ob = this.state.kbArticles.find(item => name === item.name);
        if(ob !== undefined) {
            let url = KB_ARTICLES_DOC + ob.uri;
            if(url) window.open(url, '_blank').focus();
            return true;
        }
        return false;
    }

    closeAppSlider() {
        $('#appSlider').removeClass('active');
        $('body').removeClass('no_scroll');
    }

    setServerType = (event, param) => {
        if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
            $('.create_module .distribute_sec .distribution_box').removeClass('active');
            $('.dropdown_component .custom_radio').removeClass('active');
            $('.create_module .planOption_sec .plan_box').removeClass('active');
            $('.create_module .distribute_sec .newDistribute_tab').removeClass("active");
            $('.create_module .distribute_sec .createdDistribute_tab').addClass("active");
            $('.create_module .distribute_sec .marketPlace_tab').removeClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.newDistribute').removeClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.createdDistribute').addClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.marketPlaceCtnr').removeClass("active");
            $("#psswdRadio").removeClass("active");
            $("#auth_opt01").removeClass("active");
            $("#auth_opt00").addClass("active");
            $("#sshkeyRadio").addClass("active");
            $(".create_module .auth_ctnr_cont .authenticate_sec").removeClass("show");
            $(".create_module .auth_ctnr_cont .sshKey_sec").addClass("show");
            this.setState({ isSshKey: true }, () => this.isDisabled());
        }
        else {
            $('.create_module .distribute_sec .distribution_box').removeClass('active');
            $('.dropdown_component .custom_radio').removeClass('active');
            $('.create_module .planOption_sec .plan_box').removeClass('active');
            $('.create_module .distribute_sec .newDistribute_tab').addClass("active");
            $('.create_module .distribute_sec .createdDistribute_tab').removeClass("active");
            $('.create_module .distribute_sec .marketPlace_tab').removeClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.newDistribute').addClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.createdDistribute').removeClass("active");
            $('.create_module .distribute_box_container .dist_box_wrap.marketPlaceCtnr').removeClass("active");
            $("#psswdRadio").removeClass("active");
            $("#auth_opt01").removeClass("active");
            $("#auth_opt00").addClass("active");
            $("#sshkeyRadio").addClass("active");
            $(".create_module .auth_ctnr_cont .authenticate_sec").removeClass("show");
            $(".create_module .auth_ctnr_cont .sshKey_sec").addClass("show");
            this.setState({ isSshKey: true }, () => this.isDisabled());

        }
        let locInstanceForm = this.state.instanceForm;
        if(param === "cloud") {
            locInstanceForm.isBackupEnabled = true;
            $('.main').addClass('full-width');
            $(".distribute_sec.bare-metal-distribution").hide();
            $("#distrSectionCloud").show();
        }
        else {
            locInstanceForm.isBackupEnabled = false;
            if(this.state.isUserSubscribed) {
                $('.main').removeClass('full-width');
                $(".distribute_sec.bare-metal-distribution").hide();
                $("#distrSectionCloud").hide();
            }
            else {
                $('.main').removeClass('full-width');
                $(".distribute_sec.bare-metal-distribution").show();
                $("#distrSectionCloud").hide();
            }

        }


        document.getElementById("selectAll").checked = false;
        locInstanceForm.unitName = '';
        locInstanceForm.ram = '';
        locInstanceForm.distName = '';
        locInstanceForm.distrVersionName = '';
        locInstanceForm.version = '';
        locInstanceForm.instSet = '';
        locInstanceForm.flavorRefId = '';
        locInstanceForm.imageRefId = '';
        locInstanceForm.distName = '';
        locInstanceForm.monthlyRate = '0';
        locInstanceForm.unit = 1;
        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
        }
        let bareMetalUnique = this.state.bareMetalImagesUnique;
        for(var i = 0; i < bareMetalUnique.length; i++) {
            bareMetalUnique[i].selectedVersion = undefined;
        }
        let sshKeysLoc = this.state.sshKeys;
        sshKeysLoc.forEach(item => {
            item.isSelected = false;
        });
        this.setState({
            unitErrorMessg: "",
            instanceForm: locInstanceForm,
            bmrPrice: 0,
            bmrFlavorRefId: "",
            bmrLimit: 1,
            bmrQuery: "",
            isRequestSubmitted: true,
            uniqueDistImages: uniqueDistImages,
            bareMetalImagesUnique: bareMetalUnique,
            sshKeys: sshKeysLoc,
            isSshKey: true,
            uuidList: []
        });

        if(this.state.classType) {

            if(param === "cloud") {
                this.setState({
                    isPlanAvailable: false,
                    isBmr: false,
                    isCloud: true,
                    isPrepaidMonthly: true,
                    isYearly: false,
                    discCode: this.state.nonBmDiscCode,
                    discPerce: this.state.nonBmDiscPerce,
                    discVal: this.state.nonBmDiscVal
                });
            }
            else {
                this.setState({
                    isPlanAvailable: true,
                    isBmr: true,
                    isCloud: false,
                    isYearly: false,
                    isPrepaidMonthly: false,
                    discCode: this.state.bmDiscCode,
                    discPerce: this.state.bmDiscPerce,
                    discVal: this.state.bmDiscVal
                });
            }

        }
        else {
            if(param === "cloud") {
                this.setState({
                    isBmr: false,
                    isCloud: true,
                    isPrepaidMonthly: true,
                    isYearly: false,
                    discCode: this.state.nonBmDiscCode,
                    discPerce: this.state.nonBmDiscPerce,
                    discVal: this.state.nonBmDiscVal
                });
            }
            else {
                this.setState({
                    isBmr: true,
                    isCloud: false,
                    isYearly: false,
                    isPrepaidMonthly: false,
                    discCode: this.state.bmDiscCode,
                    discPerce: this.state.bmDiscPerce,
                    discVal: this.state.bmDiscVal
                });
            }
        }
        this.uncheckCheckBox();
        this.isDisabled();

    };

    getBmFlavours = (region) => {
        this.setState({
            isAction: true,
            bmrFlavourPlans: []
        });
        let userId = localStorage.getItem("userId");
        let plans = [];
        axiosInstance.get(API_HOST + "/baremetal/getbmflavours/" + region + "/" + userId, axiosRequestWithAuth).then
            (resp => {
                let data = resp.data;

                if(data === undefined || data === null) {
                    return plans;
                }
                data.forEach(elem => {
                    let newElem = {
                        id: elem.flavour_id,
                        monthlyRate: elem.monthly_price,
                        type: elem.type
                    };
                    let nameArr = elem.name.split(' ');


                    let regandtype = nameArr[0].toString().split('/');
                    newElem.planName = nameArr[1];
                    newElem.region = regandtype[0];
                    newElem.parenttype = regandtype[1];
                    if(nameArr[1] !== undefined) {
                        let details = nameArr[1].toString().split('/');
                        newElem.ram = elem.ram / 1024 + ' GB';
                        let cpu = ' CPU';
                        if(elem.vcpus > 1) {
                            cpu = ' CPUs';
                        }
                        newElem.cpus = elem.vcpus + cpu;
                        newElem.storage = elem.disk + ' GB';
                        newElem.hourlyRate = parseFloat(newElem.monthlyRate / (28 * 24)).toFixed(4);
                        newElem.bandwidth = elem.bandwidth;
                    } else {
                        newElem.ram = '';
                        newElem.cpus = '';
                        newElem.storage = '';
                    }
                    newElem.processor = elem.processor;
                    newElem.diskType = elem.disk_type;
                    newElem.ethernet = elem.ethernet;
                    newElem.threads = elem.threads;
                    newElem.type = elem.type;
                    newElem.available = elem.available;
                    newElem.units = elem.units;
                    newElem.resourceClass = elem.resourceClass;
                    plans.push(newElem);
                });
                let sortedPlans = this.sortPlanByAmount(plans);
                this.setState({
                    bmrFlavourPlans: sortedPlans
                });
                setTimeout(() => {
                    this.setState({
                        isAction: false
                    });
                }, 2000);
            })
            .catch(error => {
                this.setState({
                    isAction: false
                });
            });
    };

    checkBmrInputs = (event) => {
        event.preventDefault();
        if(this.state.instanceForm.region.length <= 0) {
            this.setState({
                regionErrorMsg: "Select atleast a region"
            });
        }
        else if(this.state.bmrFlavorRefId.length <= 0) {
            this.setState({
                planErrorMessg: "Select atleast a plan"
            });
            document.getElementById("planErrorMsg").scrollIntoView(true);
        }
        else if(this.state.instanceForm.unit === undefined || this.state.instanceForm.unit === '') {
            document.getElementById('other-final_create_sec').scrollIntoView(true);
            document.getElementById('unitbox').focus();
            this.setState({ unitErrorMessg: 'Minimum 1 unit is required.' });
            return false;
        }
        else {

            if(this.state.isBlocked) {
                this.setState({
                    userBlockType: "bmr"
                });
                $(".blockUser_popup").addClass('active');
                $("body").addClass("no_scroll");

            }
            else {
                $("body").addClass("no_scroll");

                this.setState({
                    isBMRConfrimPopup: true,

                });
            }


        }

    };
    bmrFunLimit = (param) => {
        if(param === "increase") {
            let form = this.state.instanceForm;
            form.unit = ++form.unit;
            if(form.unit > 25) {
                form.unit = 25;
            }
            this.setUnitName(form.unit);
            this.setState({ instanceForm: form, unitErrorMessg: '' });

        }
        else {
            let unit = this.state.instanceForm.unit;
            if(unit === undefined || unit === '' || unit === 1) {
                return;
            }
            let form = this.state.instanceForm;
            form.unit = --form.unit;
            this.setUnitName(form.unit);
            this.setState({ instanceForm: form, unitErrorMessg: '' });
        }
    };

    setBmrPlan = (event, bmr) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        $(event.currentTarget).toggleClass('active');


        if($(".plan_box.available").hasClass("active")) {
            $('main').removeClass('full-width');
            $('.main_section').removeClass('bare-metal-server-available');
            $(".other-details-sec").hide();
            $(".distribute_sec").hide();
            $(".distribute_sec.bare-metal-distribution").show();
            if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
                $('.newDistribute_tab').removeClass('active');
                $('.newDistribute').removeClass('active');
                $('.marketPlace_tab').removeClass('active');
                $('.createdDistribute_tab').addClass('active');
                $('.createdDistribute').addClass('active');
            }
        }
        else if($(".plan_box.available_on_request").hasClass("active")) {
            $('.main_section').addClass('bare-metal-server-available');
            $('main').addClass('full-width');

            $(".other-details-sec").show();
            $(".distribute_sec").hide();
            $(".distribute_sec.bare-metal-distribution").hide();
        }

        if(bmr.available == "true") {
            this.setState({
                classType: true,
                isPlanAvailable: true
            });
            let form = this.state.instanceForm;
            form.flavorRefId = bmr.id;
            form.processor = bmr.cpus;
            form.parentProc = bmr.processor;
            form.diskType = bmr.diskType;
            form.threads = bmr.threads;
            form.storage = bmr.storage;
            form.ram = bmr.ram;
            form.unit = 1;
            form.monthlyRate = Number(bmr.monthlyRate);
            this.setState({
                instanceForm: form,
                unitsAvail: Number(bmr.units),
                resourceClass: bmr.resourceClass,
                selectedFlavor: bmr,
                isBMPlan: true,
                isYearly: true,
                isPrepaidMonthly: false
            }, this.isDisabled());
        }
        else {
            let form = this.state.instanceForm;
            form.unit = 1;
            this.setState({
                classType: false,
                isPlanAvailable: false
            });
            this.setState({
                instanceForm: form,
                bmrFlavorRefId: bmr.id,
                bmrPrice: bmr.monthlyRate,
                bmrProcessor: bmr.cpus,
                bmrParentProc: bmr.processor,
                bmrDiskType: bmr.diskType,
                bmrThreads: bmr.threads,
                bmrStorage: bmr.storage,
                unitsAvail: Number(bmr.units),
                bmrRam: bmr.ram,
                isRequestSubmitted: false,
                isBMPlan: false
            });
        }


        this.setState({ planErrorMessg: '', unitErrorMessg: '' });
    };

    setBmrQueries = (event) => {
        this.setState({
            bmrQuery: event.target.value
        });
    };

    openUserBlockPopup = () => {

        $(".blockUser_popup").addClass('active');
        $("body").addClass("no_scroll");
    };

    submitBmrRequest = () => {
        $("body").removeClass("no_scroll");

        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
            return;
        }
        this.setState({
            isAction: true,
            isBMRConfrimPopup: false
        });
        const body = {
            bmrFlavourId: this.state.bmrFlavorRefId,
            bmrRegion: this.state.instanceForm.region,
            bmrLimit: this.state.instanceForm.unit,
            bmrQuery: this.state.bmrQuery,
            discCode: this.state.discCode
        };
        instanceService.submitBmr(body).then(resp => {
            if(resp == "SUCCESS") {
                SessionService.setCookie("_bm_count", "show");
                localStorage.setItem("bmMsg", "show");
                this.navigateFromBM();


            }
            else if(resp == "PAYMENT_FAILED_USER") {
                this.setState({
                    isAction: false,
                    msgType: "error",
                    message: "An error occurred while processing the card details. Contact your admin."
                });
            }
            else if(resp == "PAYMENT_FAILED") {
                this.setState({
                    isAction: false,
                    msgType: "error",
                    message: "Error while processing your payment, please check credit card or change the credit card details"
                });
            }
            else {
                this.setState({
                    isAction: false,
                    msgType: "error",
                    message: "Bare Metal request failed"
                });
            }
        }).catch(error => {
            this.setState({
                isAction: false,
                msgType: "error",
                message: "Bare Metal request failed"
            });
        });
    };

    handlebmrUnits = (event) => {
        let val = event.target.value;
        let getNum = val.split();
    };

    submitEnterBm = (e) => {

        if(e.key === 'Enter') {
            this.checkBmrInputs(e);
        }
    };
    checkRegionForSpeedLink = (region) => {
        let flag = true;
        /*let regionList = ["TX2","TX3","LA2","BOS1","CO1","ATL1","NJ1","PDX1","PX1",
        "LA3",
        "MIA1",
        "NC1",
        "ORD1",
        "PA1",
        "SEA1",
        "SFO1",
        "TX1",
        "VA1","NYC1"];
        for(let i=0;i<regionList.length;i++){
            if(regionList[i] == region){
                flag = true
            }
        }*/
        if(flag) {
            this.setState({
                showSpeed: true,
                setLink: "https://speedtest-" + region + ".idrivecompute.com"
            });
        }
        else {
            this.setState({
                showSpeed: false,
                setLink: ""
            });
        }

    };
    redirectToSpeedTest = () => {
        let region = this.state.instanceForm.region.toLowerCase();

        let url = "https://speedtest-" + region + ".idrivecompute.com";
        window.open(url, "_blank");
    };
    dataCenterForbiddenMsg = () => {
        if(this.state.forbiddenErrorMessg) {
            return (
                String.raw`${ this.state.forbiddenErrorMessg }`.replace("os_compute_api:servers:create", "create action")
            );
        } else {
            return null;
        }
    };
    render() {
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        const { classes } = this.props;
        let plan_type = this.state.isPrepaidMonthly ? 'Prepaid Monthly' : this.state.isYearly ? 'Prepaid Yearly' : 'Postpaid Monthly';
        let uniqueDistList = [];
        if(this.state.isBmr) {
            uniqueDistList = this.state.bareMetalImagesUnique;
        }
        else {

            uniqueDistList = this.state.uniqueDistImages;
        }
        uniqueDistList.forEach(item => {
            if(item.distImagesMenu === undefined) item.distImagesMenu = [];
        }
        );
        const backupCss = `
         .stb{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;
        const customCss = `
         .st0{display:none;}
         .st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
         .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;

        const snapCss = `
        .sts{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;
        return (
            <body className="create_module" >
                <main className={ this.state.isBmr && !this.state.isPlanAvailable ? "full_width" : "" }>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'instances' }></LeftNav>
                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ false } showBmr={ false } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="title_txt">
                                            {/*<span className="text bold_600">Create&nbsp;-&nbsp;</span>*/ }
                                            <span className="title_info">Create a virtual instance</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className={
                            this.state.classType ?
                                !this.state.isPlanAvailable ? "main_section bare_metal_serverCreate cloud_storage_instance" : "main_section bare_metal_serverCreate bare_metal_server"
                                :
                                !this.state.isBmr ? "main_section cloud_storage_instance" : "main_section bare_metal_server" }>
                            <div className="main_body_container">
                                <div className="createModule_wrapper" >
                                    <section className="storage_ctnr" style={ { display: "none" } }>
                                        <h3>Select Server Type</h3>
                                        <p className="h3_title_txt" style={ { display: "none" } }>Choose your server type of your instance</p>
                                        <div className="storage_opt_blk">
                                            <div className="storage_wdgt" onClick={ (e) => this.state.showBmrBox ? this.setServerType(e, "cloud") : undefined }> <a href="#" onClick={ e => e.preventDefault() } className={ this.state.isBmr ? "storageOpt cloudStorage" : "storageOpt cloudStorage active" }> <i className="icon"></i> <span>Virtual Server</span>
                                                <p className="storage_des">VMs with shared resources with a choice of dedicated hyper threads along with rich memory</p></a> </div>
                                            <div className="storage_wdgt" style={ { display: this.state.showBmrBox ? "" : "none" } } onClick={ (e) => this.setServerType(e, "bmr") }> <a href="#" onClick={ e => e.preventDefault() } className={ this.state.isBmr ? "storageOpt bmrStorage active" : "storageOpt bmrStorage" }> <i className="icon"></i> <span>Bare Metal Server</span>
                                                <p className="storage_des">Dedicated single-tenant hardware over the cloud with high performance</p>
                                            </a> </div>
                                        </div>
                                    </section>
                                    <section className="dataCenter_sec" >
                                        <span className="error_msg create_err_msg" style={ { display: this.state.forbiddenErrorMessg ? 'block' : 'none' } } dangerouslySetInnerHTML={ { __html: this.dataCenterForbiddenMsg() } }></span>
                                        <span className="error_msg create_err_msg" style={ { display: this.state.maxInstErrorMessg ? 'block' : 'none' } }>You can create up to 25 instances in a region. If you need to create more instances,<a href="https://www.idrivecompute.com/support.htm" target="_blank"> Contact support</a></span>
                                        <span id="errorMessg" className="error_msg create_err_msg" style={ { display: this.state.errorMessg ? 'block' : 'none' } }>{ this.state.errorMessg }</span>
                                        <h3>Select a Region</h3>
                                        <p className="h3_title_txt" style={ { display: "none" } }>Select a region nearest to your current location. </p>
                                        <span className="error_msg create_err_msg">{ this.state.regionErrorMsg }</span>
                                        <div className="inp_row no_label">

                                            <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                                <label style={ { display: "none" } }>Regions</label>
                                                <div className="region_select_container" >
                                                    <div className="slectBox" onClick={ (e) => this.getRegionDropdown(e) } >
                                                        <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                            <textarea id="regionId" name="region" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="off"></textarea>
                                                        </div>
                                                        <ul>
                                                            <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })
                                                                <span style={ { display: this.state.isBmr ? "none" : "" } } className={ Number(this.state.instanceForm.regionCapcity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ this.state.instanceForm.regionCapcity }%<i></i> { Number(this.state.instanceForm.regionCapcity) < 20 ? "Limited Capacity" : "Capacity Available" }</span>
                                                            </li>
                                                        </ul>
                                                        <span className="dropArrow" > <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                            <title>drop-down</title>
                                                            <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                        </svg>
                                                        </span>
                                                        <span className="vcpu_label" style={ { display: this.state.isBmr ? "none" : "" } }>Capacity Available</span>
                                                    </div>

                                                    <div className="regionSelect_options" style={ { maxHeight: "inherit", overflowY: "inherit" } }>
                                                        <ScrollArea ref={ this.scrollRef }
                                                            speed={ 0.8 }
                                                            style={ { maxHeight: "245px" } }
                                                            vertical={ true }
                                                            horizontal={ false }
                                                            minScrollSize={ 10 }
                                                            smoothScrolling={ true }
                                                            verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1", } }
                                                            verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                            stopScrollPropagation={ true }


                                                        >

                                                            { this.state.regionListFilter.length <= 0 ?

                                                                <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 && !this.state.isregionselected ? "" : "none" } }>
                                                                    <li>No matching region found</li>
                                                                </ul>

                                                                :

                                                                <ul>

                                                                    { this.state.regionListFilter.map((region, i) =>
                                                                        <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })
                                                                            <span style={ { display: this.state.isBmr || region.status != 1 ? "none" : "" } } className={ Number(region.capacity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ region.capacity }%<i></i> { Number(region.capacity) < 20 ? "Limited Capacity" : "Capacity Available" }</span>
                                                                            <span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                        </li>
                                                                    ) }

                                                                </ul>
                                                            }
                                                        </ScrollArea>
                                                    </div>

                                                </div>
                                            </div>
                                            <a href={ this.state.setLink } className="speedTest_link" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank">Perform Network Speed Test for this Region</a>
                                            <a data-tip data-for="speedlink" href={ this.state.setLink } className="speedTest_link speedTest_btn" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank">Perform Network Speed Test for this Region</a>
                                            <ReactTooltip id="speedlink" place="top" effect='solid'>Perform Network Speed Test for this Region</ReactTooltip>
                                        </div>
                                        {/*<p style={{display:this.state.isBmr?"none":""}} classname="note_txt region_note"><strong>Note: </strong>The overall performance of the instances depend on the capacity available at the selected region.</p>*/ }
                                    </section>
                                    <section className="distribute_sec" id="distrSectionCloud"  >
                                        <span className="error_msg create_err_msg" style={ { paddingTop: '2%', paddingLeft: '1.5%' } }>{ this.state.distErrorMessg }</span>
                                        <div className="custom_tabs_wrap">
                                            <ul>
                                                <li className="newDistribute_tab active" style={ { display: this.state.distributeDisplay } } onClick={ this.onDistrTabClick }>Choose a distribution</li>
                                                <li className="createdDistribute_tab" style={ { display: this.state.isBmr ? "none" : "" } } onClick={ this.onImageTabClick }>Images</li>
                                                <li className="marketPlace_tab" style={ { display: this.state.isBmr ? "none" : this.state.distributeDisplay } } onClick={ () => this.onAppTabTabClick() }>Application Stack</li>
                                            </ul>
                                        </div>
                                        <div className="distribute_box_container clearfix">

                                            <div className="dist_box_wrap newDistribute active">
                                                {/* <p className="distribution_info">Select an appropriate Linux distribution</p> */ }
                                                { uniqueDistList
                                                    .map((distImage, i) => <div className={ distImage.isSelected ? "distribution_box active" : "distribution_box" } key={ distImage.distribution } onClick={ (e) => this.distributionBoxClick(e, distImage.distribution) }>
                                                        <div className="os_Img">
                                                            <div className={ "icon_img " + distImage.distribution.toLowerCase() }>
                                                                <span className="icon">
                                                                    <svg x="0px" y="0px" viewBox="0 0 28.6 26.6" style={ { display: distImage.distribution.toLowerCase() == 'rocky linux' ? 'block' : 'none' } } enableBackground="new 0 0 28.6 26.6;" xmlSpace="preserve">
                                                                        <g>
                                                                            <path className="rk0" d="M21.4,14.2c0.4-1.1,0.6-2.3,0.6-3.5C22,4.8,17.2,0,11.3,0S0.6,4.8,0.6,10.7c0,2.9,1.2,5.6,3.1,7.5L14.5,7.4
                                                                    L21.4,14.2L21.4,14.2z M19.5,17.6l-4.9-4.9l-7.7,7.7c1.4,0.6,2.9,1,4.5,1C14.6,21.3,17.5,19.9,19.5,17.6L19.5,17.6z"></path>
                                                                        </g>
                                                                    </svg>
                                                                    <svg id="Layer_1" x="0px" y="0px" width="28.6px" height="26.6px" viewBox="0 0 28.6 26.6" style={ { display: distImage.distribution.toLowerCase() == 'almalinux' ? 'block' : 'none' } } enableBackground="new 0 0 28.6 26.6;" xmlSpace="preserve">
                                                                        <g>
                                                                            <path id="path22" className="al0" d="M19.8,11.9c0.9-0.1,1.7,0.5,1.7,1.4c0.1,1-0.6,1.7-1.5,1.8c-0.9,0.1-1.7-0.6-1.7-1.5
                                                                                C18.2,12.7,18.8,12,19.8,11.9z"></path>
                                                                            <path id="path24" className="al0" d="M8.6,19.4c0-0.9,0.7-1.6,1.6-1.6s1.7,0.8,1.7,1.7c0,0.8-0.7,1.6-1.5,1.6
                                                                                C9.3,21.1,8.6,20.4,8.6,19.4z"></path>
                                                                            <path id="path26" className="al0" d="M11.1,9.1c-0.1,0.1-0.2,0-0.2-0.1C9.6,6.6,10,3.5,12.3,1.7c0.6-0.5,1.7-0.6,2.2-0.1
                                                                                c0.2,0.2,0.2,0.4,0.3,0.6c0.1,0.5,0.2,1.1,0.5,1.5c0.4,0.5,0.9,0.6,1.4,0.6s1-0.1,1.3,0.5c0.2,0.3,0.1,1.6-0.2,1.8
                                                                                c-0.1,0.1-0.2,0-0.4,0c-0.8-0.3-1.7-0.3-2.5-0.2c-0.3,0-0.4,0-0.4-0.4c0-0.5-0.1-1-0.4-1.5c-0.5-1-1.5-1-2.2-0.1
                                                                                c-0.5,0.7-0.7,1.6-0.8,2.4C11.1,7.6,11.1,8.3,11.1,9.1L11.1,9.1z"></path>
                                                                            <path id="path28" className="al0" d="M12,9.6c-0.1-0.1,0-0.2,0.1-0.3c2-1.8,5-2.2,7.3-0.4c0.6,0.5,1,1.5,0.7,2.1
                                                                                c-0.1,0.2-0.3,0.4-0.5,0.4c-0.5,0.2-1,0.4-1.3,0.9s-0.4,1-0.2,1.6c0.1,0.5,0.3,1-0.2,1.4c-0.2,0.2-1.4,0.5-1.8,0.2
                                                                                C16,15.4,16,15.3,16,15.1c0.1-0.9-0.1-1.7-0.4-2.5c-0.1-0.3-0.1-0.4,0.2-0.5c0.5-0.1,1-0.4,1.3-0.7c0.8-0.7,0.6-1.7-0.4-2.1
                                                                                C15.9,8.9,15,9,14.2,9.1C13.5,9.2,12.7,9.4,12,9.6z"></path>
                                                                            <path id="path30" className="al0" d="M11.6,10.6c0.1-0.1,0.2-0.1,0.3,0c2.3,1.4,3.5,4.2,2.5,6.9c-0.3,0.7-1.2,1.4-1.9,1.2
                                                                                c-0.3-0.1-0.4-0.2-0.6-0.4c-0.3-0.4-0.7-0.8-1.2-1c-0.6-0.2-1.1-0.1-1.6,0.2c-0.4,0.2-0.8,0.6-1.4,0.2c-0.3-0.2-0.8-1.3-0.7-1.6
                                                                                C7.1,16,7.2,16,7.4,16c0.9-0.1,1.6-0.6,2.3-1.1c0.2-0.2,0.4-0.2,0.6,0.1c0.3,0.4,0.6,0.8,1.1,1c0.9,0.5,1.8,0.1,1.9-1
                                                                                c0.1-0.9-0.2-1.7-0.5-2.4C12.4,11.9,12,11.2,11.6,10.6z"></path>
                                                                            <path id="path32" className="al0" d="M10.4,10.8c-0.1,0.7-0.5,1.4-0.9,2c-1.3,1.9-3.1,2.7-5.4,2.5c-0.8-0.1-1.5-0.7-1.6-1.4
                                                                                c0-0.3,0-0.5,0.2-0.7c0.2-0.3,0.5-0.6,0.6-1c0.2-0.8-0.1-1.4-0.6-2C1.9,9.4,2,8.7,2.9,8.2C3,8.1,3.1,8.1,3.3,8
                                                                                c0.2-0.1,0.4-0.1,0.5,0.1c0.3,0.8,1,1.4,1.7,1.9c0.2,0.2,0.2,0.4,0,0.6c-0.4,0.5-0.7,1-0.7,1.7c-0.1,0.8,0.4,1.3,1.2,1.3
                                                                                c0.5,0,1-0.2,1.4-0.4c1.1-0.6,1.9-1.4,2.7-2.2C10.3,10.8,10.3,10.7,10.4,10.8z"></path>
                                                                            <path id="path34" className="al0" d="M4.7,3.4c0.1,0,0.2,0,0.4,0.1c1.3,0.2,2.1-0.2,2.5-1.4C7.9,1.3,8.5,1,9.3,1.5c0,0,0,0,0.1,0
                                                                                C10.2,2,10.2,2,9.7,2.7C9.3,3.3,9.1,3.9,9,4.6C8.9,5,8.8,5.1,8.4,4.9c-0.6-0.2-1.2-0.2-1.8,0c-0.7,0.2-1,0.8-0.7,1.5
                                                                                C6.2,7.3,7,7.7,7.6,8.1c0.7,0.5,1.4,0.7,2.2,1c0.1,0,0.3,0,0.2,0.2c0,0.1-0.2,0.1-0.3,0.1C8.1,9.5,6.6,9.2,5.4,8.2s-2-2.1-1.9-3.7
                                                                                C3.6,3.9,4,3.5,4.7,3.4z"></path>
                                                                            <path id="path36" className="al0" d="M1.8,13.3C1,13.4,0.1,12.7,0,11.8C-0.1,11,0.6,10.1,1.4,10c0.9-0.1,1.8,0.5,1.8,1.4
                                                                                C3.3,12.2,2.8,13.2,1.8,13.3z"></path>
                                                                            <path id="path38" className="al0" d="M16.6,0.7c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.8-0.6,1.7-1.5,1.7C16,4,15.2,3.3,15.1,2.4
                                                                                C15,1.6,15.7,0.8,16.6,0.7z"></path>
                                                                            <path id="path40" className="al0" d="M7.4,1.4c0.1,0.9-0.5,1.7-1.5,1.8C5.1,3.3,4.2,2.6,4.1,1.9C4,0.9,4.6,0.1,5.5,0S7.3,0.6,7.4,1.4z"></path>
                                                                        </g>
                                                                    </svg>
                                                                    <svg x="0px" y="0px" style={ { display: distImage.distribution.toLowerCase() === 'fedora' ? 'block' : 'none' } }
                                                                        viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                        <circle display="none" fill="#DCA5CA" cx="15" cy="15" r="14" />
                                                                        <g>
                                                                            <path fill="#FFFFFF" d="M17.1,3C11.5,1.9,5.4,5.5,3.5,11.3c-0.9,2.6-0.6,5.1-0.7,7.7c0,8.8-0.6,8.2,8.3,8.2c1.4,0,2.8,0,4.1,0
c6.2-0.2,11.2-4.9,11.9-11C27.7,9.9,23.4,4.1,17.1,3z M18.4,16.9L18.4,16.9h-3.1v3c0,2.9-2.3,5.2-5.2,5.2c-0.6,0-1-0.4-1-1
s0.4-1,1-1c1.8,0,3.1-1.3,3.1-3.1v-3.1h-3.1c-0.7,0-1.1-0.4-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1v-3.1c0-2.9,2.3-5.2,5.2-5.2
c0.6,0,1,0.4,1,1.1s-0.4,1.1-1,1.1c-1.8,0-3.1,1.3-3.1,3.1v3.1h3.1c0.6,0,1,0.5,1,1C19.4,16.5,19,16.9,18.4,16.9z"/>
                                                                            <g>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.3,11.3c0-0.1,0-0.1,0-0.2C15.4,11.2,15.3,11.2,15.3,11.3z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.6,9.2L16.6,9.2L16.6,9.2z" />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.4,10.8c0-0.1,0.1-0.2,0.1-0.3
C15.5,10.6,15.5,10.7,15.4,10.8z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M14.7,8c-0.2,0.2-0.3,0.3-0.4,0.5C14.4,8.3,14.6,8.2,14.7,8z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.5,7.4c-0.1,0.1-0.2,0.1-0.3,0.2
C15.3,7.5,15.4,7.4,15.5,7.4z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.7,10.3c0.1-0.1,0.1-0.2,0.2-0.3
C15.8,10.1,15.7,10.2,15.7,10.3z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.2,9.5c-0.1,0.1-0.1,0.1-0.2,0.2
C16.1,9.7,16.1,9.6,16.2,9.5z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.2,11.7c0-0.7,0.1-1.4,0.4-2C13.3,10.3,13.2,10.9,13.2,11.7
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.2,25c-0.3,0.1-0.6,0.1-0.9,0.1
C10.6,25.1,10.9,25.1,11.2,25z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M18.5,6.5C19,6.6,19.4,7,19.4,7.6c0,0.7-0.4,1.1-1,1.1
c1.7,0,3.1,1.3,3.1,3.1c0,1.7-1.3,3.1-3.1,3.1l0,0c0.5,0,1,0.5,1,1c0,0.7-0.4,1.1-1,1.1l0,0l0,0c2.9,0,5.2-2.4,5.2-5.3
C23.6,8.8,21.3,6.6,18.5,6.5z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15,21.6c0.1-0.2,0.2-0.4,0.2-0.7C15.1,21.2,15.1,21.4,15,21.6
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.6,9.6c0.1-0.3,0.3-0.6,0.5-0.8C13.9,9,13.7,9.3,13.6,9.6z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.4,24.9c1.6-0.4,2.9-1.5,3.5-3C14.3,23.4,13,24.5,11.4,24.9
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M9.1,24.1c0-0.6,0.4-1,1-1c0.8,0,1.5-0.3,2-0.7
c-0.5,0.5-1.2,0.7-2.1,0.7c-1.8,0-3.1-1.3-3.1-3.1c0-1.8,1.3-3.1,3.1-3.1l0,0c-0.6,0-1.1-0.5-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1
H9.9c-2.9,0-5.2,2.4-5.2,5.3s2.4,5.1,5.3,5.1l0,0C9.6,25.1,9.1,24.7,9.1,24.1z"/>
                                                                            </g>
                                                                        </g>
                                                                    </svg>

                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'debian' ? 'block' : 'none' } }>
                                                                        <path fill="#FFFFFF" d="M12.1,27.2c-0.7-0.3-1.4-0.6-2.1-1c-1.4-0.8-2.5-1.9-3.4-3.2c-0.5-0.7-0.9-1.4-1.2-2.1  c-0.3-0.7-0.6-1.5-0.8-2.2c-0.2-0.8-0.4-1.6-0.5-2.4c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.7,0.6-3.3,1.4-4.8C6,8.2,6.4,7.5,7,6.9  c0.5-0.7,1.2-1.3,1.8-1.8c2.8-2.1,6.5-2.8,9.9-1.9c0.8,0.2,1.7,0.6,2.4,1c0.8,0.4,1.5,1,2.2,1.7c2.6,2.7,3.4,6.5,2.1,10  c-0.7,1.7-1.9,3.1-3.5,4.1c-1.6,0.9-3.5,1.2-5.2,0.8c-0.9-0.2-1.7-0.6-2.4-1.2c-0.7-0.6-1.2-1.3-1.6-2.1c-0.3-0.8-0.5-1.7-0.4-2.6  c0.1-0.9,0.5-1.7,1.1-2.3c0.5-0.7,1.2-1.1,2-1.3c0.8-0.1,0.8,0.2,0.1,0.5c-0.6,0.3-1.1,0.8-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.8  c0,0.6,0.2,1.2,0.6,1.7c0.6,1,1.7,1.7,2.9,1.9c1.2,0.2,2.4-0.1,3.3-0.8c0.9-0.7,1.6-1.7,2-2.8c0.3-1.1,0.4-2.4,0.1-3.5  c-0.3-1.1-0.9-2.2-1.7-3c-0.4-0.4-0.9-0.7-1.4-1c-0.5-0.3-1.1-0.5-1.7-0.7c-0.6-0.2-1.2-0.3-1.8-0.4c-0.6,0-1.2,0-1.8,0.1  c-1.2,0.2-2.4,0.7-3.4,1.4c-2.1,1.5-3.5,3.8-4,6.4c-0.2,1.3-0.2,2.7,0,4c0.1,0.7,0.3,1.3,0.5,2c0.2,0.7,0.5,1.3,0.8,2  c0.6,1.3,1.5,2.4,2.6,3.3C11.5,26,12.8,27.5,12.1,27.2z"></path>
                                                                    </svg>
                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'ubuntu' ? 'block' : 'none' } }>
                                                                        <circle fill="#FFFFFF" cx="6.1" cy="15" r="2.1"></circle>
                                                                        <circle fill="#FFFFFF" cx="22.4" cy="24.5" r="2.1"></circle>
                                                                        <circle fill="#FFFFFF" cx="22.4" cy="5.6" r="2.1"></circle>
                                                                        <path fill="#FFFFFF" d="M16.9,20.1c-0.6,0-1.2-0.1-1.7-0.3l-2.1,3.6c1.2,0.5,2.5,0.8,3.8,0.8c0.6,0,1.3-0.1,1.9-0.2  c0.3-2,2.1-3.4,4.1-3.2c0.3,0,0.6,0.1,0.9,0.2c1.3-1.4,2.1-3.2,2.3-5.1h-4.1C21.4,18.3,19.3,20.1,16.9,20.1z"></path>
                                                                        <path fill="#FFFFFF" d="M23.8,9c-1.9,0.8-4-0.2-4.8-2.1c-0.1-0.3-0.2-0.6-0.2-0.9c-0.6-0.1-1.2-0.2-1.9-0.2c-1.4,0-2.8,0.3-4,0.9  l2.4,3.4c2.7-0.8,5.5,0.7,6.4,3.3c0.1,0.2,0.1,0.4,0.2,0.7H26C25.8,12.3,25,10.4,23.8,9z"></path>
                                                                        <path fill="#FFFFFF" d="M8.2,12c1.7,1.2,2.1,3.5,0.9,5.1c-0.2,0.3-0.5,0.6-0.9,0.9c0.6,1.8,1.8,3.3,3.3,4.4l2.1-3.6  c-2.1-1.8-2.4-5.1-0.5-7.2c0.2-0.2,0.4-0.5,0.7-0.7l-2.4-3.3C9.9,8.8,8.8,10.3,8.2,12z"></path>
                                                                    </svg>
                                                                    <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'centos' ? 'block' : 'none' } }><g><path fill="#FFF" d="M13.1,14.1l0.9,0.9l-0.9,0.9H7v2.9l-3.7-3.7L7,11.3v2.8H13.1L13.1,14.1L13.1,14.1L13.1,14.1z M15.8,6.8h7.4   v7.4h-7.4V6.8L15.8,6.8L15.8,6.8L15.8,6.8z"></path><path fill="#FFF" d="M15.8,13.1L15,13.9l-0.9-0.9V7h-2.9L15,3.3L18.6,7h-2.8V13.1L15.8,13.1L15.8,13.1L15.8,13.1z M15.8,15.8   h7.4v7.4h-7.4V15.8L15.8,15.8L15.8,15.8L15.8,15.8z"></path><path fill="#FFF" d="M16.8,15.8L16,15l0.9-0.9h6.1v-2.9l3.7,3.7l-3.7,3.7v-2.8H16.8L16.8,15.8L16.8,15.8L16.8,15.8z M6.8,15.8   h7.4v7.4H6.8V15.8L6.8,15.8L6.8,15.8L6.8,15.8z"></path><path fill="#FFF" d="M14.1,16.8l0.9-0.9l0.9,0.9v6.1h2.9l-3.7,3.7l-3.7-3.7h2.8V16.8L14.1,16.8L14.1,16.8L14.1,16.8z M6.8,6.8   h7.4v7.4H6.8V6.8L6.8,6.8L6.8,6.8L6.8,6.8z"></path><path fill="#dda4cb" d="M6.5,6.5h7.9v7.9H6.5V6.5L6.5,6.5L6.5,6.5L6.5,6.5L6.5,6.5z M7,13.9h6.9V7H7V13.9L7,13.9L7,13.9L7,13.9z    M15.5,6.5h7.9v7.9h-7.9V6.5L15.5,6.5L15.5,6.5L15.5,6.5z M16,13.9h6.9V7H16V13.9L16,13.9L16,13.9L16,13.9z M15.5,15.5h7.9v7.9   h-7.9V15.5L15.5,15.5L15.5,15.5L15.5,15.5z M16,22.9h6.9V16H16V22.9L16,22.9L16,22.9L16,22.9z M6.5,15.5h7.9v7.9H6.5V15.5L6.5,15.5   L6.5,15.5L6.5,15.5z M7,22.9h6.9V16H7V22.9L7,22.9L7,22.9L7,22.9L7,22.9z"></path><path fill="#dda4cb" d="M8.6,20.6L3,15l5.6-5.6l5.6,5.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6z M3.7,15l4.9,4.9   l4.9-4.9l-4.9-4.9L3.7,15L3.7,15L3.7,15L3.7,15z M15,14.2L9.3,8.6L15,3l5.6,5.6L15,14.2L15,14.2L15,14.2L15,14.2z M10.1,8.6   l4.9,4.9l4.9-4.9L15,3.7L10.1,8.6L10.1,8.6L10.1,8.6L10.1,8.6z M21.3,20.6L15.7,15l5.6-5.6l5.6,5.6L21.3,20.6L21.3,20.6L21.3,20.6   L21.3,20.6z M16.5,15l4.9,4.9l4.9-4.9l-4.9-4.9L16.5,15L16.5,15L16.5,15L16.5,15z M15,26.9l-5.6-5.6l5.6-5.6l5.6,5.6L15,26.9   L15,26.9L15,26.9L15,26.9z M10.1,21.3l4.9,4.9l4.9-4.9L15,16.5L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3z"></path></g></svg>

                                                                    <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'opensuse leap' ? 'block' : 'none' } }>
                                                                        <g>
                                                                            <path fill="#FFFFFF" d="M23.6,13.7c0.6,0.3,1.3,0.4,2.1,0.3c0.6-0.1,1.2-0.4,1.7-0.8c0.1-0.1,0.1-0.1,0.1-0.3
		c-0.2-0.6-0.4-1.3-0.6-1.9c-0.3-0.6-0.7-1.1-1.3-1.3c-1.6-0.6-3.2-1-4.9-1.3c-0.1,0-0.2,0-0.2,0.1c0,0.2,0,0.4,0,0.6
		c0,0.2,0,0.2-0.2,0.1c-2.3-0.7-2.7-1.1-5.2-1.1c-2.1,0-4,0.4-5.9,1.2C7.4,10,5.7,11,4.5,12.4c-1.1,1.3-2,2.7-2.1,4.4
		c-0.1,1.3,0.3,2.5,1.3,3.5c1.1,1.1,2.4,1.5,3.9,1.3c2.2-0.2,3.1-2.1,3-3.5c-0.2-1.7-1.9-3.1-3.6-2.7c-1.3,0.3-2.1,1.5-1.6,2.7
		c0.4,1,1.7,1.4,2.5,0.9c0.3-0.2,0.4-0.4,0.3-0.7C8,18,7.7,17.9,7.4,17.9c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.9-0.2-0.7-0.7
		c0.1-0.3,0.3-0.4,0.5-0.5c0.5-0.2,1.3,0,1.7,0.5c0.9,1,0.4,2.5-0.9,2.8c-0.3,0.1-0.5,0.1-0.8,0.1c-1.5,0-2.8-1.3-2.8-2.8
		c0-1.2,0.7-2.3,1.9-2.8c1-0.4,2.1-0.3,3.1,0.2c1.5,0.7,2.6,1.9,3.1,3.6c0,0.1,0.1,0.2,0.2,0.3c0.4,0.3,1,0.4,1.4,0.7
		c0.1,0,0.1,0.1,0.2,0c-0.1-0.4-0.1-0.9-0.1-1.3c0-1.1,0.5-1.9,1.5-1.8c0.5,0,0.4-0.3,1.2,0.4c0.4,0.4,0.4,1.3,0.9,1.8
		c0.2,0.2,0.4,0.4,0.5,0.5c0.6,0.3,1.3,0.5,1.8,0.8c0.1,0,0.1,0.1,0.2,0c0-0.1-0.1-0.2-0.2-0.3c-0.4-0.5-0.6-1-0.8-1.6
		c-0.1-0.4-0.2-0.9-0.1-1.3c0.1-0.4,0.4-0.6,0.8-0.7c0.3,0,0.5,0,0.8,0c0.9,0.1,1.8,0.2,2.7,0.2c1.2-0.1,2.2-0.4,3.3-0.9
		c0.4-0.2,0.7-0.5,0.8-1.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.7,0.3-1.4,0.4-2.2,0.3
		c-1-0.3-1.8-0.6-2.7-1.1c0,0-0.1,0-0.1-0.1c-0.2-0.3-0.3-0.6-0.4-1c0.1,0,0.2,0.1,0.3,0.2C22.1,13,22.8,13.4,23.6,13.7z M24.6,10.1
		c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C23,10.9,23.7,10.1,24.6,10.1z"></path>
                                                                            <path fill="#FFFFFF" d="M24.5,12.8c0.6,0,1.2-0.4,1.2-1.1c0-0.6-0.4-1.2-1.1-1.2s-1.2,0.4-1.2,1.1C23.4,12.3,23.9,12.8,24.5,12.8z
		 M24.8,11.2c0.3,0,0.5,0.1,0.5,0.3s-0.2,0.4-0.5,0.4c-0.3,0-0.4-0.1-0.4-0.3C24.3,11.3,24.5,11.2,24.8,11.2z"></path>
                                                                        </g>
                                                                    </svg>

                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="os_desc">
                                                            <div className="desc_wrap">
                                                                <div className="dist_name text_elipses">{ distImage.distribution }</div>
                                                                <div className="dist_version">{ distImage.selectedVersion === undefined ? 'Select Version' : distImage.selectedVersion }</div>
                                                            </div>
                                                        </div>
                                                        <div className="menu_icon" onClick={ (e) => this.onMenuIconClick(e, distImage.distribution) }>
                                                            <svg
                                                                x="0px"
                                                                y="0px"
                                                                viewBox="0 0 4.9 17.1"
                                                                enableBackground="new 0 0 4.9 17.1"
                                                                xmlSpace="preserve">
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    fill="#7A8E9D"
                                                                    d="M2.5,10.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S3.6,10.5,2.5,10.5  z M2.5,4.4c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C4.5,3.6,3.6,4.4,2.5,4.4z M2.5,12.6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2  S1.4,12.6,2.5,12.6z"></path>
                                                            </svg>
                                                        </div>
                                                        <ul className="dropdown_component distribute_option_dropdown">
                                                            <span className="arrow_pointer"></span>
                                                            { distImage.distImagesMenu.map((item, i) =>
                                                                <li className="opt1" key={ i }>
                                                                    <label className={ item.isImage ? "custom_radio active" : "custom_radio" }>{ item.version }{ item.instructionSet !== undefined ? '*' + item.instructionSet : item.instructionSet }
                                                                        <input type="radio" name="distribute_options_box1" onClick={ (e) => this.distVersionSelect(e, item, distImage) } />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </li>
                                                            ) }

                                                        </ul>
                                                    </div>)
                                                }
                                            </div>
                                            <div className="dist_box_wrap createdDistribute">

                                                {/* <p className="distribution_info" >Add a new custom image of a virtual hard disk</p> */ }
                                                {
                                                    this.state.images.map((image, i) =>
                                                        <div key={ i } className={ image.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onImageClick(e, image) }>
                                                            <div className="os_Img">
                                                                <div className={ "icon_img " + image.image_type }>
                                                                    <span className="icon" style={ { display: image.image_type === 'backup' ? '' : 'none' } }>
                                                                        <svg x="0px" y="0px"
                                                                            viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                            <style type="text/css">{ backupCss }</style>
                                                                            <g>
                                                                                <path className="stb" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
			c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                <path className="stb" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
			c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                <path className="stb" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
			c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                <path className="stb" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
			C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                            </g>
                                                                        </svg>
                                                                    </span>
                                                                    <span className="icon" style={ { display: image.image_type === 'snapshot' ? '' : 'none' } }>
                                                                        <svg x="0px" y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                            viewBox="0 0 192 192" xmlSpace="preserve">
                                                                            <style type="text/css">{ snapCss }</style>
                                                                            <path className="sts" d="M150.7,150.7H41.3c-8.6,0-15.6-7-15.6-15.6V72.6c0-8.6,7-15.6,15.6-15.6h13l2.6-7.8c0-4.3,3.5-7.8,7.8-7.8h62.5
	c4.3,0,7.8,3.5,7.8,7.8l2.6,7.8h13c8.6,0,15.6,7,15.6,15.6v62.5C166.3,143.7,159.3,150.7,150.7,150.7z M115.5,49.1H76.5
	c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9h39.1c2.2,0,3.9-1.8,3.9-3.9S117.7,49.1,115.5,49.1z M96,72.6c-17.3,0-31.3,14-31.3,31.3
	s14,31.3,31.3,31.3s31.3-14,31.3-31.3S113.3,72.6,96,72.6z M96,119.4c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6
	S104.6,119.4,96,119.4z"/>
                                                                        </svg>
                                                                    </span>
                                                                    <span className="icon" style={ { display: image.image_type === undefined ? '' : 'none' } }>
                                                                        <svg y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                            viewBox="0 0 192 192" xmlSpace="preserve">
                                                                            <style type="text/css">{ customCss }</style>
                                                                            <g className="st0">
                                                                                <path className="st1" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
		c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                <path className="st1" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
		c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                <path className="st1" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
		c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                <path className="st1" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
		C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                            </g>
                                                                            <g>
                                                                                <path className="st2" d="M112.7,69.4H59.4V76h53.3V69.4z M66,93.1v-7.7c0-1.5-1.2-2.8-2.8-2.8H42.6c-1.4,0-2.3-1.6-1.6-2.8l15.1-25.1
		c2-3.3,5.6-5.4,9.5-5.4h40.7c3.9,0,7.5,2,9.5,5.4l12.9,21.4c1.3-0.1,2.6-0.2,3.9-0.2c2,0,4,0.2,6,0.5l-15.8-27.6
		c-2.2-3.8-6.3-6.2-10.7-6.2H59.8c-4.4,0-8.5,2.4-10.7,6.2L28.3,85.4c-1.5,2.6-2.2,5.5-2.2,8.4v35.4c0,3.7,3,6.7,6.7,6.7h65.3
		c-3.4-5.9-5.4-12.7-5.4-20c0-7.3,2-14.1,5.4-20H68.9C67.3,96,66,94.7,66,93.1z M132.6,82.7c-18.4,0-33.3,14.9-33.3,33.3
		s14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3S151,82.7,132.6,82.7z M136.9,142.3c-18,2.8-33.3-12.5-30.5-30.5
		c1.7-11.2,10.9-20.4,22.1-22.1c18-2.8,33.3,12.5,30.5,30.5C157.2,131.4,148.1,140.6,136.9,142.3z M126,122.6v13.3h13.3v-13.3h13.3
		l-20-26.6l-20,26.6H126z M66,56v6.7h40V56H66z"/>
                                                                            </g>
                                                                        </svg>

                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="os_desc">
                                                                <div className="desc_wrap">
                                                                    <div className="dist_name text_elipses" data-tip data-for={ image.name }>{ image.name }<ReactTooltip id={ image.name } place="top" effect="solid">{ image.name }</ReactTooltip></div>
                                                                    <div className="dist_version text_elipses" style={ { display: image.min_disk > 0 ? '' : 'none' } }>Minimum storage disk required : { image.min_disk } GB </div>
                                                                    {/* <div className="dist_version text_elipses"><span style={{display:image.image_type?'':'none'}}>{image.image_type},</span> Size {formatBytesFloat(image.size)}, Min-Disk {image.min_disk}GB </div> */ }
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                }
                                                {/* <div className="cta_wrap clearfix">
                                                    <div className="btn_wrap btnDefaultPad">
                                                        <input type="button" name="" value="Add Image" className="common_cta_btn add_img_cta" onClick={()=>this.navigateToImage()}/>
                                                    </div>
                                                </div> */}
                                                <div className="cta_wrap">
                                                    <p className="distribution_info dbw_desc" style={ { display: this.state.images.length === 0 ? '' : 'none' } }>Upload an image from hard disk or import via URL to create an instance with custom OS of your choice. Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                                    <p className="distribution_info dbw_desc" style={ { display: this.state.images.length > 0 ? '' : 'none' } }>Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                                </div>
                                            </div>
                                            <div className="dist_box_wrap marketPlaceCtnr">
                                                { this.state.applicationStack.map((appImage, i) =>
                                                    <div key={ i } className={ appImage.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onAppImageClick(e, appImage) }>
                                                        <div className="os_Img">
                                                            <div className={ "icon_img " + appImage.rawName?.replace(/[&\s]/g, '').toLowerCase() }>
                                                                <span className="icon"></span>
                                                            </div>
                                                        </div>
                                                        <div className="os_desc">
                                                            <div className="desc_wrap">
                                                                <div className="dist_name text_elipses" title={ appImage.nameDesc } >{ appImage.rawName } { appImage.nameDesc !== undefined ? ':' + appImage.nameDesc : '' }</div>
                                                                <div className="dist_version">on { appImage.os } { appImage.version }</div>
                                                            </div>
                                                        </div>
                                                        <div className="marketInf_icon" onClick={ () => this.showAppSlider(appImage.rawName.toLowerCase()) }>
                                                            <span className="question_icon active" data-toggle="tooltip" data-placement="bottom" title="View app details" data-original-title="View app details">
                                                                <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#fff" stroke="#739bb2" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                    <text transform="matrix(1 0 0 1 9.0724 15.4681)" fill="#739bb2" fontFamily="'Roboto-Medium'" fontSize="14px">i</text>
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>

                                                ) }
                                            </div>

                                        </div>
                                    </section>

                                    <section className="planOption_sec" id="planSectionCloud">
                                        <div className="plan_optHead">
                                            <h3>Choose a plan</h3>
                                            <p className="h3_title_txt bmrPara" >The IDrive Compute bare-metal provides direct access to all server resources without any virtualization layer.</p>
                                            <p className="h3_title_txt cloudPara">Shared CPU instances support medium workloads with optimum resource utilization at an affordable price while dedicated CPU instances are ideal to handle heavy workloads.</p>
                                            <span className="error_msg create_err_msg" style={ { display: this.state.planErrorMessg ? 'block' : 'none' } } >{ this.state.planErrorMessg }</span>
                                            <div className="customPlans_radio_wrap">
                                                <label className={ this.state.isScpu ? "custom_radio active" : "custom_radio" } onClick={ (e) => this.planRadioClick(e, 'SCPU') }>Shared CPU
                                                    <input type="radio" defaultChecked="checked" name="customPlan_options" />
                                                    <span className="checkmark"></span>
                                                </label>
                                                <label className={ !this.state.isScpu ? "custom_radio active" : "custom_radio " } onClick={ (e) => this.onDscpuPlanClick(e, 'DCPU') }>Dedicated CPU
                                                    <input type="radio" name="customPlan_options" />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="plan_bmr" >
                                            <div className="plan_container">
                                                <div className="bmr_yearly_plan show" >

                                                    <div className="comingsoon_blk" style={ { display: "none" } }>
                                                        <p>Coming Soon</p>
                                                    </div>
                                                    <div className="bmr_offerBlk no-bg" style={ { display: this.state.bmrFlavourPlans.length > 0 ? "block" : "none" } }>
                                                        <div className="offer-text-blk">
                                                            <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                            <p className="subscribe-txt" style={ { display: "none" } }>Subscribe to prepaid yearly plans and get discounts</p>
                                                        </div>
                                                    </div>


                                                    {/*<div className="plan_box available active"> */ }
                                                    { this.state.bmrFlavourPlans.map((bmr, index) =>
                                                        <div className={ bmr.available == "true" ? "plan_box available" : "plan_box available_on_request" } onClick={ (e) => this.setBmrPlan(e, bmr) }>
                                                            <div className="cost_details">
                                                                <div className="plan_storage"> <span>{ Number.isInteger(convertgbtotb(bmr.storage)) ? convertgbtotb(bmr.storage) + ".0 TB" : Number(bmr.storage.slice(0, -2).trim()) < 1024 ? bmr.storage : convertgbtotb(bmr.storage) + " TB" } { bmr.diskType }</span> </div>
                                                                <div className="cost_option2 actual_cost"><span className="strike_thru">${ bmr.monthlyRate * 12 }</span><span className="cost-sub">/year</span></div>
                                                                <div className="cost_option1">${ bmr.monthlyRate * 12 - (bmr.monthlyRate * 12) / this.state.discVal }<span className="cost-sub">/first year</span></div>
                                                            </div>
                                                            <div className="plan_details">
                                                                <div className="plan-config"> <span><b>{ bmr.processor }</b> Processor</span> <small><b>{ bmr.cpus }</b> cores / <b>{ bmr.threads }</b> threads</small> </div>
                                                                <ul className="detail_info">
                                                                    <li>
                                                                        <div className="col1">Memory</div>
                                                                        <div className="col2">{ bmr.ram }</div>
                                                                    </li>

                                                                    <li style={ { display: "none" } }>
                                                                        <div className="col1">Bandwidth</div>
                                                                        <div className="col2">{ bmr.bandwidth == -1 ? "unlimited" : formatBandwidthBytes(bmr.bandwidth, true) }</div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="col1">Ethernet</div>
                                                                        <div className="col2">{ bmr.ethernet }</div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            { bmr.available == "true" ?
                                                                <div className="plan_button available">
                                                                    <div className="btn-text ">Available</div>
                                                                </div>
                                                                :
                                                                <div className="plan_button available on_request">
                                                                    <div className="btn-text ">Available on Request</div>
                                                                </div>
                                                            }

                                                        </div>

                                                    ) }
                                                    <p className="offer_note" style={ { display: this.state.bmrFlavourPlans.length > 0 ? "block" : "none" } }><span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:<br></br>
                                                        - The { this.state.discPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.<br></br>
                                                        - Any charges incurred for the bare metal request will not be refunded.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="plan_cloud" >
                                            <div className="plan_scpu" style={ { display: this.state.isScpu ? 'block' : 'none' } }>
                                                <div className="plan_container" >
                                                    <ul className="scpu_tabs">
                                                        <li class={ this.state.isPrepaidMonthly ? "active" : "" } data-tabs="SCPU-prepaid-monthly" onClick={ () => this.onDiffPlanClick('prepaidMonthly') }>
                                                            <p class="text">Prepaid Monthly</p>
                                                        </li>
                                                        <li data-tabs="SCPU-monthly" className={ this.state.isPrepaidMonthly || this.state.isYearly ? "" : "active" } onClick={ () => this.onDiffPlanClick('monthly') }><p className="text">Postpaid Monthly</p></li>
                                                        <li className={ this.state.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.onDiffPlanClick('yearly') }><p className="text">Prepaid Yearly</p></li>

                                                    </ul>
                                                    <div className={ this.state.isYearly ? "scpu_yearly_plan show" : "scpu_monthly_plan tabCtnr show" }>
                                                        <div className="scpu_offerBlk no-bg">
                                                            { this.state.isYearly &&
                                                                <div className="offer-text-blk">
                                                                    <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                                    <p className="subscribe-txt">Subscribe to prepaid yearly plans and get discounts</p>
                                                                </div> }
                                                            { this.state.isPrepaidMonthly &&
                                                                <div className="offer-text-blk">
                                                                    <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discMonPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                                    <p className="subscribe-txt">Subscribe to prepaid monthly plans and get discounts</p>
                                                                </div> }
                                                            { !this.state.isYearly && !this.state.isPrepaidMonthly &&
                                                                <div className="offer-text-blk">
                                                                    <p className="monthly-paytxt">Pay as you use with monthly postpaid plans</p>
                                                                </div>
                                                            }

                                                        </div>
                                                        { this
                                                            .state
                                                            .instanceFilterPlans
                                                            .map((instancePlan, i) => <div className={ instancePlan.isSelected ? "plan_box active" : "plan_box " } key={ i } onClick={ (e) => this.planBoxClick(e, instancePlan) }>
                                                                { this.state.isYearly ?
                                                                    <div className="cost_details">
                                                                        <div className="cost_option2 actual_cost">
                                                                            <span className="strike_thru">$ { instancePlan.monthlyRate * 12 }</span><span className="cost-sub">/year</span>
                                                                        </div>
                                                                        <div className="cost_option1">$ { instancePlan.monthlyRate * 12 - (instancePlan.monthlyRate * 12) / this.state.discVal }<span className="cost-sub">/first year</span></div>
                                                                    </div> :
                                                                    this.state.isPrepaidMonthly ?
                                                                        <div className="cost_details">
                                                                            <div className="cost_option2 actual_cost">
                                                                                <span className="strike_thru">$ { instancePlan.monthlyRate }</span><span className="cost-sub">/month</span>
                                                                            </div>
                                                                            <div className="cost_option1">$ { instancePlan.monthlyRate - (instancePlan.monthlyRate) / this.state.discMonVal }<span className="cost-sub">/month</span></div>
                                                                        </div> :
                                                                        <div className="cost_details">

                                                                            <div className="cost_option1">$ { instancePlan.monthlyRate }<span className="cost-sub">/month</span>
                                                                            </div>
                                                                            <div className="cost_option2">${ instancePlan.hourlyRate }/hour</div>
                                                                        </div> }
                                                                <div className="plan_details">
                                                                    <ul className="detail_info">
                                                                        <li>
                                                                            <div className="col1">RAM</div>
                                                                            <div className="col2">{ instancePlan.ram }</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="col1">Processor</div>
                                                                            <div className="col2">{ instancePlan.processor }</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="col1">NVMe Storage</div>
                                                                            <div className="col2">{ instancePlan.storage }</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="col1">Bandwidth</div>
                                                                            <div className="col2">{ formatBandwidthBytes(instancePlan.bandwidth, this.state.isYearly) }</div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>)
                                                        }
                                                        { this.state.isYearly && <p className="offer_note" >
                                                            <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                                            <br></br>- The { this.state.discPerce }% offer on yearly instances is applicable for the first year only. For subsequent years, normal charges are applicable.
                                                            <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                                            <span style={ { display: this.state.isBmr ? "none" : "" } }><br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.</span>
                                                        </p> }
                                                        { this.state.isPrepaidMonthly && <p className="offer_note" >
                                                            <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                                            <br></br>- The { this.state.discMonPerce }% offer on monthly instances is applicable for the first year only. For subsequent years, normal charges are applicable.
                                                            <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                                            {/* <span style={ { display: this.state.isBmr ? "none" : "" } }><br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.</span> */ }
                                                        </p> }

                                                    </div>
                                                    <div className='scpu_monthly_plan tabCtnr show'>
                                                        <div className='monthly'>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="plan_container" style={ { display: !this.state.isScpu ? 'block' : 'none' } }>
                                                <DedicatedCpu dcpuList={ this.state.dcpuList } planBoxClick={ (e, param) => this.planBoxClick(e, param) } isPrepaidMonthly={ this.state.isPrepaidMonthly }
                                                    isYearly={ this.state.isYearly } onDiffPlanClick={ (type) => this.onDiffPlanClick(type) } discMonPerce={ this.state.discMonPerce } discMonVal={ this.state.discMonVal }
                                                    discPerce={ this.state.discPerce } discVal={ this.state.discVal } setYearly={ () => this.setState({ isYearly: false, isPrepaidMonthly: true }) } selectedFlavor={ this.state.selectedFlavor } />
                                            </div>
                                        </div>
                                    </section>
                                    <section className="distribute_sec bare-metal-distribution" id="distrSection"  >
                                        <span className="error_msg create_err_msg" style={ { paddingTop: '2%', paddingLeft: '1.5%' } }>{ this.state.distErrorMessg }</span>
                                        <div className="custom_tabs_wrap">
                                            <ul>
                                                <li className="newDistribute_tab active" style={ { display: this.state.distributeDisplay } } onClick={ this.onDistrTabClick }>Choose a distribution</li>
                                                <li className="createdDistribute_tab" onClick={ this.onImageTabClick }>Images</li>
                                                <li className="marketPlace_tab" style={ { display: this.state.isBmr ? "none" : this.state.distributeDisplay } } onClick={ () => this.onAppTabTabClick() }>Application Stack</li>
                                            </ul>
                                        </div>
                                        <div className="distribute_box_container clearfix">

                                            <div className="dist_box_wrap newDistribute active">
                                                {/* <p className="distribution_info">Select an appropriate Linux distribution</p> */ }
                                                { uniqueDistList
                                                    .map((distImage, i) => <div className="distribution_box" key={ distImage.distribution } onClick={ (e) => this.distributionBoxClick(e, distImage.distribution) }>
                                                        <div className="os_Img">
                                                            <div className={ "icon_img " + distImage.distribution.toLowerCase() }>
                                                                <span className="icon">
                                                                    <svg x="0px" y="0px" style={ { display: distImage.distribution.toLowerCase() === 'fedora' ? 'block' : 'none' } }
                                                                        viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                        <circle display="none" fill="#DCA5CA" cx="15" cy="15" r="14" />
                                                                        <g>
                                                                            <path fill="#FFFFFF" d="M17.1,3C11.5,1.9,5.4,5.5,3.5,11.3c-0.9,2.6-0.6,5.1-0.7,7.7c0,8.8-0.6,8.2,8.3,8.2c1.4,0,2.8,0,4.1,0
c6.2-0.2,11.2-4.9,11.9-11C27.7,9.9,23.4,4.1,17.1,3z M18.4,16.9L18.4,16.9h-3.1v3c0,2.9-2.3,5.2-5.2,5.2c-0.6,0-1-0.4-1-1
s0.4-1,1-1c1.8,0,3.1-1.3,3.1-3.1v-3.1h-3.1c-0.7,0-1.1-0.4-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1v-3.1c0-2.9,2.3-5.2,5.2-5.2
c0.6,0,1,0.4,1,1.1s-0.4,1.1-1,1.1c-1.8,0-3.1,1.3-3.1,3.1v3.1h3.1c0.6,0,1,0.5,1,1C19.4,16.5,19,16.9,18.4,16.9z"/>
                                                                            <g>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.3,11.3c0-0.1,0-0.1,0-0.2C15.4,11.2,15.3,11.2,15.3,11.3z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.6,9.2L16.6,9.2L16.6,9.2z" />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.4,10.8c0-0.1,0.1-0.2,0.1-0.3
C15.5,10.6,15.5,10.7,15.4,10.8z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M14.7,8c-0.2,0.2-0.3,0.3-0.4,0.5C14.4,8.3,14.6,8.2,14.7,8z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.5,7.4c-0.1,0.1-0.2,0.1-0.3,0.2
C15.3,7.5,15.4,7.4,15.5,7.4z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.7,10.3c0.1-0.1,0.1-0.2,0.2-0.3
C15.8,10.1,15.7,10.2,15.7,10.3z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.2,9.5c-0.1,0.1-0.1,0.1-0.2,0.2
C16.1,9.7,16.1,9.6,16.2,9.5z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.2,11.7c0-0.7,0.1-1.4,0.4-2C13.3,10.3,13.2,10.9,13.2,11.7
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.2,25c-0.3,0.1-0.6,0.1-0.9,0.1
C10.6,25.1,10.9,25.1,11.2,25z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M18.5,6.5C19,6.6,19.4,7,19.4,7.6c0,0.7-0.4,1.1-1,1.1
c1.7,0,3.1,1.3,3.1,3.1c0,1.7-1.3,3.1-3.1,3.1l0,0c0.5,0,1,0.5,1,1c0,0.7-0.4,1.1-1,1.1l0,0l0,0c2.9,0,5.2-2.4,5.2-5.3
C23.6,8.8,21.3,6.6,18.5,6.5z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15,21.6c0.1-0.2,0.2-0.4,0.2-0.7C15.1,21.2,15.1,21.4,15,21.6
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.6,9.6c0.1-0.3,0.3-0.6,0.5-0.8C13.9,9,13.7,9.3,13.6,9.6z"
                                                                                />
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.4,24.9c1.6-0.4,2.9-1.5,3.5-3C14.3,23.4,13,24.5,11.4,24.9
z"/>
                                                                                <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M9.1,24.1c0-0.6,0.4-1,1-1c0.8,0,1.5-0.3,2-0.7
c-0.5,0.5-1.2,0.7-2.1,0.7c-1.8,0-3.1-1.3-3.1-3.1c0-1.8,1.3-3.1,3.1-3.1l0,0c-0.6,0-1.1-0.5-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1
H9.9c-2.9,0-5.2,2.4-5.2,5.3s2.4,5.1,5.3,5.1l0,0C9.6,25.1,9.1,24.7,9.1,24.1z"/>
                                                                            </g>
                                                                        </g>
                                                                    </svg>

                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'debian' ? 'block' : 'none' } }>
                                                                        <path fill="#FFFFFF" d="M12.1,27.2c-0.7-0.3-1.4-0.6-2.1-1c-1.4-0.8-2.5-1.9-3.4-3.2c-0.5-0.7-0.9-1.4-1.2-2.1  c-0.3-0.7-0.6-1.5-0.8-2.2c-0.2-0.8-0.4-1.6-0.5-2.4c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.7,0.6-3.3,1.4-4.8C6,8.2,6.4,7.5,7,6.9  c0.5-0.7,1.2-1.3,1.8-1.8c2.8-2.1,6.5-2.8,9.9-1.9c0.8,0.2,1.7,0.6,2.4,1c0.8,0.4,1.5,1,2.2,1.7c2.6,2.7,3.4,6.5,2.1,10  c-0.7,1.7-1.9,3.1-3.5,4.1c-1.6,0.9-3.5,1.2-5.2,0.8c-0.9-0.2-1.7-0.6-2.4-1.2c-0.7-0.6-1.2-1.3-1.6-2.1c-0.3-0.8-0.5-1.7-0.4-2.6  c0.1-0.9,0.5-1.7,1.1-2.3c0.5-0.7,1.2-1.1,2-1.3c0.8-0.1,0.8,0.2,0.1,0.5c-0.6,0.3-1.1,0.8-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.8  c0,0.6,0.2,1.2,0.6,1.7c0.6,1,1.7,1.7,2.9,1.9c1.2,0.2,2.4-0.1,3.3-0.8c0.9-0.7,1.6-1.7,2-2.8c0.3-1.1,0.4-2.4,0.1-3.5  c-0.3-1.1-0.9-2.2-1.7-3c-0.4-0.4-0.9-0.7-1.4-1c-0.5-0.3-1.1-0.5-1.7-0.7c-0.6-0.2-1.2-0.3-1.8-0.4c-0.6,0-1.2,0-1.8,0.1  c-1.2,0.2-2.4,0.7-3.4,1.4c-2.1,1.5-3.5,3.8-4,6.4c-0.2,1.3-0.2,2.7,0,4c0.1,0.7,0.3,1.3,0.5,2c0.2,0.7,0.5,1.3,0.8,2  c0.6,1.3,1.5,2.4,2.6,3.3C11.5,26,12.8,27.5,12.1,27.2z"></path>
                                                                    </svg>
                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'ubuntu' ? 'block' : 'none' } }>
                                                                        <circle fill="#FFFFFF" cx="6.1" cy="15" r="2.1"></circle>
                                                                        <circle fill="#FFFFFF" cx="22.4" cy="24.5" r="2.1"></circle>
                                                                        <circle fill="#FFFFFF" cx="22.4" cy="5.6" r="2.1"></circle>
                                                                        <path fill="#FFFFFF" d="M16.9,20.1c-0.6,0-1.2-0.1-1.7-0.3l-2.1,3.6c1.2,0.5,2.5,0.8,3.8,0.8c0.6,0,1.3-0.1,1.9-0.2  c0.3-2,2.1-3.4,4.1-3.2c0.3,0,0.6,0.1,0.9,0.2c1.3-1.4,2.1-3.2,2.3-5.1h-4.1C21.4,18.3,19.3,20.1,16.9,20.1z"></path>
                                                                        <path fill="#FFFFFF" d="M23.8,9c-1.9,0.8-4-0.2-4.8-2.1c-0.1-0.3-0.2-0.6-0.2-0.9c-0.6-0.1-1.2-0.2-1.9-0.2c-1.4,0-2.8,0.3-4,0.9  l2.4,3.4c2.7-0.8,5.5,0.7,6.4,3.3c0.1,0.2,0.1,0.4,0.2,0.7H26C25.8,12.3,25,10.4,23.8,9z"></path>
                                                                        <path fill="#FFFFFF" d="M8.2,12c1.7,1.2,2.1,3.5,0.9,5.1c-0.2,0.3-0.5,0.6-0.9,0.9c0.6,1.8,1.8,3.3,3.3,4.4l2.1-3.6  c-2.1-1.8-2.4-5.1-0.5-7.2c0.2-0.2,0.4-0.5,0.7-0.7l-2.4-3.3C9.9,8.8,8.8,10.3,8.2,12z"></path>
                                                                    </svg>
                                                                    <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'centos' ? 'block' : 'none' } }><g><path fill="#FFF" d="M13.1,14.1l0.9,0.9l-0.9,0.9H7v2.9l-3.7-3.7L7,11.3v2.8H13.1L13.1,14.1L13.1,14.1L13.1,14.1z M15.8,6.8h7.4   v7.4h-7.4V6.8L15.8,6.8L15.8,6.8L15.8,6.8z"></path><path fill="#FFF" d="M15.8,13.1L15,13.9l-0.9-0.9V7h-2.9L15,3.3L18.6,7h-2.8V13.1L15.8,13.1L15.8,13.1L15.8,13.1z M15.8,15.8   h7.4v7.4h-7.4V15.8L15.8,15.8L15.8,15.8L15.8,15.8z"></path><path fill="#FFF" d="M16.8,15.8L16,15l0.9-0.9h6.1v-2.9l3.7,3.7l-3.7,3.7v-2.8H16.8L16.8,15.8L16.8,15.8L16.8,15.8z M6.8,15.8   h7.4v7.4H6.8V15.8L6.8,15.8L6.8,15.8L6.8,15.8z"></path><path fill="#FFF" d="M14.1,16.8l0.9-0.9l0.9,0.9v6.1h2.9l-3.7,3.7l-3.7-3.7h2.8V16.8L14.1,16.8L14.1,16.8L14.1,16.8z M6.8,6.8   h7.4v7.4H6.8V6.8L6.8,6.8L6.8,6.8L6.8,6.8z"></path><path fill="#dda4cb" d="M6.5,6.5h7.9v7.9H6.5V6.5L6.5,6.5L6.5,6.5L6.5,6.5L6.5,6.5z M7,13.9h6.9V7H7V13.9L7,13.9L7,13.9L7,13.9z    M15.5,6.5h7.9v7.9h-7.9V6.5L15.5,6.5L15.5,6.5L15.5,6.5z M16,13.9h6.9V7H16V13.9L16,13.9L16,13.9L16,13.9z M15.5,15.5h7.9v7.9   h-7.9V15.5L15.5,15.5L15.5,15.5L15.5,15.5z M16,22.9h6.9V16H16V22.9L16,22.9L16,22.9L16,22.9z M6.5,15.5h7.9v7.9H6.5V15.5L6.5,15.5   L6.5,15.5L6.5,15.5z M7,22.9h6.9V16H7V22.9L7,22.9L7,22.9L7,22.9L7,22.9z"></path><path fill="#dda4cb" d="M8.6,20.6L3,15l5.6-5.6l5.6,5.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6z M3.7,15l4.9,4.9   l4.9-4.9l-4.9-4.9L3.7,15L3.7,15L3.7,15L3.7,15z M15,14.2L9.3,8.6L15,3l5.6,5.6L15,14.2L15,14.2L15,14.2L15,14.2z M10.1,8.6   l4.9,4.9l4.9-4.9L15,3.7L10.1,8.6L10.1,8.6L10.1,8.6L10.1,8.6z M21.3,20.6L15.7,15l5.6-5.6l5.6,5.6L21.3,20.6L21.3,20.6L21.3,20.6   L21.3,20.6z M16.5,15l4.9,4.9l4.9-4.9l-4.9-4.9L16.5,15L16.5,15L16.5,15L16.5,15z M15,26.9l-5.6-5.6l5.6-5.6l5.6,5.6L15,26.9   L15,26.9L15,26.9L15,26.9z M10.1,21.3l4.9,4.9l4.9-4.9L15,16.5L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3z"></path></g></svg>

                                                                    <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distImage.distribution.toLowerCase() === 'opensuse leap' ? 'block' : 'none' } }>
                                                                        <g>
                                                                            <path fill="#FFFFFF" d="M23.6,13.7c0.6,0.3,1.3,0.4,2.1,0.3c0.6-0.1,1.2-0.4,1.7-0.8c0.1-0.1,0.1-0.1,0.1-0.3
		c-0.2-0.6-0.4-1.3-0.6-1.9c-0.3-0.6-0.7-1.1-1.3-1.3c-1.6-0.6-3.2-1-4.9-1.3c-0.1,0-0.2,0-0.2,0.1c0,0.2,0,0.4,0,0.6
		c0,0.2,0,0.2-0.2,0.1c-2.3-0.7-2.7-1.1-5.2-1.1c-2.1,0-4,0.4-5.9,1.2C7.4,10,5.7,11,4.5,12.4c-1.1,1.3-2,2.7-2.1,4.4
		c-0.1,1.3,0.3,2.5,1.3,3.5c1.1,1.1,2.4,1.5,3.9,1.3c2.2-0.2,3.1-2.1,3-3.5c-0.2-1.7-1.9-3.1-3.6-2.7c-1.3,0.3-2.1,1.5-1.6,2.7
		c0.4,1,1.7,1.4,2.5,0.9c0.3-0.2,0.4-0.4,0.3-0.7C8,18,7.7,17.9,7.4,17.9c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.9-0.2-0.7-0.7
		c0.1-0.3,0.3-0.4,0.5-0.5c0.5-0.2,1.3,0,1.7,0.5c0.9,1,0.4,2.5-0.9,2.8c-0.3,0.1-0.5,0.1-0.8,0.1c-1.5,0-2.8-1.3-2.8-2.8
		c0-1.2,0.7-2.3,1.9-2.8c1-0.4,2.1-0.3,3.1,0.2c1.5,0.7,2.6,1.9,3.1,3.6c0,0.1,0.1,0.2,0.2,0.3c0.4,0.3,1,0.4,1.4,0.7
		c0.1,0,0.1,0.1,0.2,0c-0.1-0.4-0.1-0.9-0.1-1.3c0-1.1,0.5-1.9,1.5-1.8c0.5,0,0.4-0.3,1.2,0.4c0.4,0.4,0.4,1.3,0.9,1.8
		c0.2,0.2,0.4,0.4,0.5,0.5c0.6,0.3,1.3,0.5,1.8,0.8c0.1,0,0.1,0.1,0.2,0c0-0.1-0.1-0.2-0.2-0.3c-0.4-0.5-0.6-1-0.8-1.6
		c-0.1-0.4-0.2-0.9-0.1-1.3c0.1-0.4,0.4-0.6,0.8-0.7c0.3,0,0.5,0,0.8,0c0.9,0.1,1.8,0.2,2.7,0.2c1.2-0.1,2.2-0.4,3.3-0.9
		c0.4-0.2,0.7-0.5,0.8-1.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.7,0.3-1.4,0.4-2.2,0.3
		c-1-0.3-1.8-0.6-2.7-1.1c0,0-0.1,0-0.1-0.1c-0.2-0.3-0.3-0.6-0.4-1c0.1,0,0.2,0.1,0.3,0.2C22.1,13,22.8,13.4,23.6,13.7z M24.6,10.1
		c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C23,10.9,23.7,10.1,24.6,10.1z"></path>
                                                                            <path fill="#FFFFFF" d="M24.5,12.8c0.6,0,1.2-0.4,1.2-1.1c0-0.6-0.4-1.2-1.1-1.2s-1.2,0.4-1.2,1.1C23.4,12.3,23.9,12.8,24.5,12.8z
		 M24.8,11.2c0.3,0,0.5,0.1,0.5,0.3s-0.2,0.4-0.5,0.4c-0.3,0-0.4-0.1-0.4-0.3C24.3,11.3,24.5,11.2,24.8,11.2z"></path>
                                                                        </g>
                                                                    </svg>

                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="os_desc">
                                                            <div className="desc_wrap">
                                                                <div className="dist_name text_elipses">{ distImage.distribution }</div>
                                                                <div className="dist_version">{ distImage.selectedVersion === undefined ? 'Select Version' : distImage.selectedVersion }</div>
                                                            </div>
                                                        </div>
                                                        <div className="menu_icon" onClick={ (e) => this.onMenuIconClick(e, distImage.distribution) }>
                                                            <svg
                                                                x="0px"
                                                                y="0px"
                                                                viewBox="0 0 4.9 17.1"
                                                                enableBackground="new 0 0 4.9 17.1"
                                                                xmlSpace="preserve">
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    fill="#7A8E9D"
                                                                    d="M2.5,10.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S3.6,10.5,2.5,10.5  z M2.5,4.4c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C4.5,3.6,3.6,4.4,2.5,4.4z M2.5,12.6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2  S1.4,12.6,2.5,12.6z"></path>
                                                            </svg>
                                                        </div>
                                                        <ul className="dropdown_component distribute_option_dropdown">
                                                            <span className="arrow_pointer"></span>
                                                            { distImage.distImagesMenu.map((item, i) =>
                                                                <li className="opt1" key={ i }>
                                                                    <label className="custom_radio">{ item.version }{ item.instructionSet !== undefined ? '*' + item.instructionSet : item.instructionSet }
                                                                        <input type="radio" name="distribute_options_box1" onClick={ (e) => this.distVersionSelect(e, item, distImage) } />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </li>
                                                            ) }

                                                        </ul>
                                                    </div>)
                                                }
                                            </div>
                                            <div className="dist_box_wrap createdDistribute">

                                                {/* <p className="distribution_info" >Add a new custom image of a virtual hard disk</p> */ }
                                                {
                                                    this.state.images.map((image, i) =>
                                                        <div key={ i } className={ image.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onImageClick(e, image) }>
                                                            <div className="os_Img">
                                                                <div className={ "icon_img " + image.image_type }>
                                                                    <span className="icon" style={ { display: image.image_type === 'backup' ? '' : 'none' } }>
                                                                        <svg x="0px" y="0px"
                                                                            viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                            <style type="text/css">{ backupCss }</style>
                                                                            <g>
                                                                                <path className="stb" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
			c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                <path className="stb" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
			c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                <path className="stb" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
			c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                <path className="stb" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
			C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                            </g>
                                                                        </svg>
                                                                    </span>
                                                                    <span className="icon" style={ { display: image.image_type === 'snapshot' ? '' : 'none' } }>
                                                                        <svg x="0px" y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                            viewBox="0 0 192 192" xmlSpace="preserve">
                                                                            <style type="text/css">{ snapCss }</style>
                                                                            <path className="sts" d="M150.7,150.7H41.3c-8.6,0-15.6-7-15.6-15.6V72.6c0-8.6,7-15.6,15.6-15.6h13l2.6-7.8c0-4.3,3.5-7.8,7.8-7.8h62.5
	c4.3,0,7.8,3.5,7.8,7.8l2.6,7.8h13c8.6,0,15.6,7,15.6,15.6v62.5C166.3,143.7,159.3,150.7,150.7,150.7z M115.5,49.1H76.5
	c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9h39.1c2.2,0,3.9-1.8,3.9-3.9S117.7,49.1,115.5,49.1z M96,72.6c-17.3,0-31.3,14-31.3,31.3
	s14,31.3,31.3,31.3s31.3-14,31.3-31.3S113.3,72.6,96,72.6z M96,119.4c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6
	S104.6,119.4,96,119.4z"/>
                                                                        </svg>
                                                                    </span>
                                                                    <span className="icon" style={ { display: image.image_type === undefined ? '' : 'none' } }>
                                                                        <svg y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                            viewBox="0 0 192 192" xmlSpace="preserve">
                                                                            <style type="text/css">{ customCss }</style>
                                                                            <g className="st0">
                                                                                <path className="st1" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
		c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                <path className="st1" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
		c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                <path className="st1" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
		c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                <path className="st1" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
		C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                            </g>
                                                                            <g>
                                                                                <path className="st2" d="M112.7,69.4H59.4V76h53.3V69.4z M66,93.1v-7.7c0-1.5-1.2-2.8-2.8-2.8H42.6c-1.4,0-2.3-1.6-1.6-2.8l15.1-25.1
		c2-3.3,5.6-5.4,9.5-5.4h40.7c3.9,0,7.5,2,9.5,5.4l12.9,21.4c1.3-0.1,2.6-0.2,3.9-0.2c2,0,4,0.2,6,0.5l-15.8-27.6
		c-2.2-3.8-6.3-6.2-10.7-6.2H59.8c-4.4,0-8.5,2.4-10.7,6.2L28.3,85.4c-1.5,2.6-2.2,5.5-2.2,8.4v35.4c0,3.7,3,6.7,6.7,6.7h65.3
		c-3.4-5.9-5.4-12.7-5.4-20c0-7.3,2-14.1,5.4-20H68.9C67.3,96,66,94.7,66,93.1z M132.6,82.7c-18.4,0-33.3,14.9-33.3,33.3
		s14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3S151,82.7,132.6,82.7z M136.9,142.3c-18,2.8-33.3-12.5-30.5-30.5
		c1.7-11.2,10.9-20.4,22.1-22.1c18-2.8,33.3,12.5,30.5,30.5C157.2,131.4,148.1,140.6,136.9,142.3z M126,122.6v13.3h13.3v-13.3h13.3
		l-20-26.6l-20,26.6H126z M66,56v6.7h40V56H66z"/>
                                                                            </g>
                                                                        </svg>

                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="os_desc">
                                                                <div className="desc_wrap">
                                                                    <div className="dist_name text_elipses" data-tip data-for={ image.name }>{ image.name }<ReactTooltip id={ image.name } place="top" effect="solid">{ image.name }</ReactTooltip></div>
                                                                    <div className="dist_version text_elipses" style={ { display: image.min_disk > 0 ? '' : 'none' } }>Minimum storage disk required : { image.min_disk } GB </div>
                                                                    {/* <div className="dist_version text_elipses"><span style={{display:image.image_type?'':'none'}}>{image.image_type},</span> Size {formatBytesFloat(image.size)}, Min-Disk {image.min_disk}GB </div> */ }
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                }
                                                {/* <div className="cta_wrap clearfix">
                                                    <div className="btn_wrap btnDefaultPad">
                                                        <input type="button" name="" value="Add Image" className="common_cta_btn add_img_cta" onClick={()=>this.navigateToImage()}/>
                                                    </div>
                                                </div> */}
                                                <div className="cta_wrap">
                                                    <p className="distribution_info dbw_desc" style={ { display: this.state.images.length === 0 ? '' : 'none' } }>Upload an image from hard disk or import via URL to create an instance with custom OS of your choice. Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                                    <p className="distribution_info dbw_desc" style={ { display: this.state.images.length > 0 ? '' : 'none' } }>Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                                </div>
                                            </div>
                                            <div className="dist_box_wrap marketPlaceCtnr">
                                                { this.state.applicationStack.map((appImage, i) =>
                                                    <div key={ i } className={ appImage.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onAppImageClick(e, appImage) }>
                                                        <div className="os_Img">
                                                            <div className={ "icon_img " + appImage.rawName.toLowerCase() }>
                                                                <span className="icon"></span>
                                                            </div>
                                                        </div>
                                                        <div className="os_desc">
                                                            <div className="desc_wrap">
                                                                <div className="dist_name text_elipses" title={ appImage.nameDesc } >{ appImage.rawName } { appImage.nameDesc !== undefined ? ':' + appImage.nameDesc : '' }</div>
                                                                <div className="dist_version">on { appImage.os } { appImage.version }</div>
                                                            </div>
                                                        </div>
                                                        <div className="marketInf_icon" onClick={ () => this.showAppSlider(appImage.rawName.toLowerCase()) }>
                                                            <span className="question_icon active" data-toggle="tooltip" data-placement="bottom" title="View app details" data-original-title="View app details">
                                                                <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#fff" stroke="#739bb2" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                    <text transform="matrix(1 0 0 1 9.0724 15.4681)" fill="#739bb2" fontFamily="'Roboto-Medium'" fontSize="14px">i</text>
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>

                                                ) }
                                            </div>

                                        </div>
                                    </section>
                                    <div className="auth_ctnr" id="authSec">
                                        <h3 className="auth_title">Authentication</h3>
                                        <div className="authPlans_radio_wrap" >
                                            <div className="radio_ctnr active" onClick={ () => this.onAuthCentrClick('sshKey') } id="sshkeyRadio">
                                                <label className="custom_radiobox active" id="auth_opt00" data-tabs="sshKeys">SSH Keys
                                                    <input type="radio" checked="checked" name="auth_options" id="auth_opt1" readOnly />
                                                    <span className="checkmark"></span>
                                                </label>
                                                <span className="question_icon active" data-tip data-for="sshTool">
                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                    </svg>
                                                </span>
                                                <ReactTooltip id="sshTool" effect="solid" place="top">A more secure authentication method</ReactTooltip>
                                            </div>
                                            <div className={ this.state.isPasswdDisabled ? "radio_ctnr disabled" : "radio_ctnr" } onClick={ () => this.onAuthCentrClick('psswd') } id="psswdRadio" disabled={ this.state.isPasswdDisabled }>
                                                <label className="custom_radiobox" id="auth_opt01" data-tabs="rootPswd">Password
                                                    <input type="radio" name="auth_options" id="auth_opt2" readOnly />
                                                    <span className="checkmark"></span>
                                                </label>
                                                <span className="question_icon active" data-tip data-for="pswdTool" >
                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                    </svg>
                                                </span>
                                                <ReactTooltip id="pswdTool" effect="solid" place="top">The root password is used to offer privileged access to a root user<br></br> to make full use of all the resources of the virtual instance.</ReactTooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="auth_ctnr_cont">
                                        <section className="sshKey_sec show"  >
                                            <h3>SSH Keys</h3>
                                            <span className="error_msg create_err_msg" style={ { display: this.state.sshErrorMessg ? 'block' : 'none' } } >{ this.state.sshErrorMessg }</span>
                                            <p className="h3_title_txt">Choose an existing SSH Key or add a new one to configure secure login authentication</p>
                                            <div className="ssh-lists">
                                                <div className="ssh-listBox" style={ { display: this.state.sshKeys.length > 1 ? "" : "none" } }>
                                                    <label className="checkBox">
                                                        <input type="checkbox" id="selectAll" name="selectall" onChange={ (e) => this.selectAllSshKeys(e) } />
                                                        <span className="checkmark"></span><b>Select All</b>
                                                    </label>
                                                </div>
                                                { this.state.sshKeys.map((sshKey, i) =>
                                                    <div className="ssh-listBox" key={ i }>
                                                        <label className="checkBox">
                                                            <input checked={ sshKey.isSelected } className="checkremo" type="checkbox" name="keyName" onChange={ (e) => this.onsshSelect(e, sshKey) } />
                                                            <span className="checkmark"></span><span data-tip data-for={ sshKey.secretref }>{ sshKey.name }</span>
                                                            <ReactTooltip id={ sshKey.secretref } effect="solid" place="top">{ sshKey.name }</ReactTooltip>
                                                        </label>
                                                    </div>
                                                ) }
                                                <input type="button" name="" defaultValue="Add SSH Key" className={ this.state.isUserSubscribed ? "add_ssh_cta disabled" : "add_ssh_cta" } onClick={ () => this.addSshClick() } disabled={ this.state.isUserSubscribed } />
                                            </div>
                                        </section>

                                        <section className="authenticate_sec" id="authSection">
                                            <h3>Root Password</h3>
                                            <div className="inp_row auth_inp_row">
                                                {/* <label>Password -
                                                <span className="sub-txt"> Create a root password to access VM</span>
                                            </label> */}
                                                <div className="auth_box_wrap">
                                                    <input id="password" type={ this.state.hidePwd ? "password" : "text" } name="password" value={ this.state.instanceForm.password } onChange={ this.formChangeHandler } className="txt_box" autoComplete="off" placeholder="Provide a password for the root user" />
                                                    <span className={ this.state.hidePwd ? "pwd_field" : "pwd_field show_pwd" } data-tip data-for="passwordinput" onClick={ () => this.setState({ hidePwd: !this.state.hidePwd }) }></span><ReactTooltip id="passwordinput" place="right" effect="solid">
                                                        { this.state.hidePwd ? "Show" : "Hide" }
                                                    </ReactTooltip>
                                                </div>
                                                <span className="question_icon">
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        viewBox="0 0 22 20"
                                                        enableBackground="new 0 0 22 20"
                                                        xmlSpace="preserve"
                                                        data-tip data-for="password">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#89A2BE"
                                                            d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text
                                                            transform="matrix(1 0 0 1 7.0724 15.4681)"
                                                            fill="#FFFFFF"
                                                            fontFamily="'Roboto-Medium'"
                                                            fontSize="16px">?</text>
                                                    </svg>
                                                </span><ReactTooltip multiline={ true } id="password" place="right" effect="solid">
                                                    Due to the restrictive nature of IDrive Compute to allow strong<br></br> passwords only, a password is suggested by us for your ease.<br></br> You may use the same password or create a new password.
                                                </ReactTooltip>
                                                <span className="comm_error_msg" >{ this.state.rootErrorMessg }</span>
                                                <div className="auth_progress" style={ { display: (this.state.instanceForm.password ? '' : 'none') } }>
                                                    <div className="progress_wrap">
                                                        <div className="progress_bar">
                                                            { this.state.psswdStrength === 'Weak' && (<span
                                                                className="percent_progress"
                                                                style={ {
                                                                    width: "10%"
                                                                } }></span>)
                                                            }
                                                            { this.state.psswdStrength === 'Strong' && (<span
                                                                className="percent_progress"
                                                                style={ {
                                                                    width: "100%", background: 'green'
                                                                } }></span>)
                                                            }
                                                        </div>
                                                        <span className="progress_content" style={ { color: (this.state.psswdStrength === 'Strong' ? 'green' : '#f6ac39') } }>{ this.state.psswdStrength }</span>
                                                        { this.state.psswdStrength === 'Weak' && (<p>Your password is weak. Choose a stronger password.</p>) }
                                                        <h4>Password requirements</h4>
                                                    </div>
                                                    <ul>
                                                        <li className={ this.state.eightCharLi ? "p_success" : "" }>At least 8 characters long</li>
                                                        <li className={ this.state.oneUpperLi ? "p_success" : "" }>Must contain 1 uppercase (first and last characters don’t count)</li>
                                                        <li className={ this.state.oneNumSpeLi ? "p_success" : "" }>Must contain 1 number and 1 special character</li>
                                                        <li className={ this.state.noNumSpeLi ? "p_success" : "" }>Cannot end in a number or special character</li>
                                                    </ul>

                                                </div>

                                            </div>

                                        </section>

                                    </div>

                                    {/* <section className="rootLogin_data_sec">
                                        <div className="rootLogin_data_container">
                                            <label className="checkBox">
                                                <input type="checkbox" name="isLoginData"  value={this.state.instanceForm.isLoginData} onChange={this.formChangeHandler}/>
                                                    <span className="checkmark"></span>
                                                    <p className="rootLogin_data_head">Allow Root login 
                                                        <span className="question_icon" data-tip data-for = "rootLogin"><svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                         <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                         <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                         </svg></span>
                                                        </p>
                                                        <ReactTooltip id="rootLogin" effect="solid">Root Login</ReactTooltip>
                                            </label>
                                            <p className="rootLogin_data_info">Enable root password login</p>
                                        </div>
                                    </section>         */}
                                    <section className="user_data_sec" id="user_data_sec">
                                        <div className="user_data_container">
                                            <label className="checkBox">
                                                <input type="checkbox" name="isUserData" value={ this.state.instanceForm.isUserData } onChange={ this.formChangeHandler } />
                                                <span className="checkmark"></span>
                                                <p className="user_data_head">User-Data (Optional) <span className="question_icon" data-tip data-for="userinfo"><svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                    <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                </svg></span></p><ReactTooltip
                                                    multiline={ true }
                                                    id="userinfo"
                                                    place="right"
                                                    effect="solid">
                                                    Provide arbitrary data to the instance during its creation.<br></br> The user data will be consumed via Cloud-Init during the first boot of the instance.<br></br> Currently, only Cloud-config format is supported.
                                                </ReactTooltip>
                                            </label>
                                            <p className="user_data_info"></p>
                                            { this.state.instanceForm.isUserData && <textarea placeholder={ this.state.udPlaceHolder } style={ { height: '225px' } } name="userData" value={ this.state.instanceForm.userData } onChange={ this.formChangeHandler } id="userdatafield"></textarea>
                                            }
                                            <span className="comm_error_msg" style={ { display: this.state.userDataErrorMessg ? 'block' : 'none', paddingLeft: '30px' } }>Enter a valid YAML indentation</span>
                                        </div>

                                    </section>

                                    <section className="final_create_sec">
                                        <h3>Finalize and Create</h3>
                                        <div className={ this.state.isYearly ? "finalCreate_col finalInstance one_col" : "finalCreate_col finalInstance" }>
                                            <div className="col1" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly || (this.state.isBmr && this.state.isBMPlan) ? 'none' : '' } }>
                                                <label className="txtBox_label">Number of instance</label>
                                                <span className="label_info">Multiple instances can be created with the same configuration</span>
                                                <div className="unit_box add_remove_field" >
                                                    <span className="sub_icon" onClick={ this.removeUnit }>
                                                        <span className="icon"></span>
                                                    </span>
                                                    <input type="text" id="unitbox" name="unit" value={ this.state.instanceForm.unit + " Unit" } onChange={ this.formChangeHandler } disabled={ this.state.isYearly } />

                                                    <span className="add_icon" onClick={ this.addUnit }>
                                                        <span className="icon"></span>
                                                    </span>
                                                </div>
                                                <span className="comm_error_msg" >{ this.state.unitErrorMessg }</span>
                                            </div>
                                            <div className="col2" style={ { marginLeft: this.state.isYearly || (this.state.isBmr && this.state.isBMPlan) ? '0' : '' } }>
                                                <label className="txtBox_label ">Name</label>
                                                <span className="label_info"> Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)</span>
                                                <div className="unit_box">
                                                    <input id="unitName" placeholder="Provide a name for the instance" autoComplete="off"
                                                        type="text"
                                                        name="unitName"
                                                        value={ this.state.instanceForm.unitName }
                                                        onChange={ this.formChangeHandler }
                                                        onFocus={ () => this.state.isUnitNameFocused ? null : this.setState({ isUnitNameFocused: true }) }
                                                    /></div>
                                                <span className="comm_error_msg" >{ this.state.unitNameErrorMessg }</span>
                                            </div>
                                        </div>
                                        {/* <p style={{display:this.state.instanceForm.unit===2?'':'none'}}>You are adding multiple instances with the same configuration. For easy identification, the instance names will be suffixed with a number. E.g., {this.state.instanceForm.unitName}-1, {this.state.instanceForm.unitName}-2 etc.</p> */ }
                                        <p className="unit-note" style={ { display: this.state.instanceForm.unit > 1 ? '' : 'none' } }>You are adding multiple instances with the same configuration. For easy identification, the instance names will be suffixed with a number. E.g., { this.state.instanceForm.unitName }-1, { this.state.instanceForm.unitName }-2, { this.state.instanceForm.unitName }-3 etc.</p>
                                    </section>
                                    <section className="optional_addOn_sec enable_bkp   ">
                                        <h3>Optional Add-ons</h3>
                                        <div className="addOn_list_wrap">
                                            <ul>
                                                <li>
                                                    <div className="addOn_container">
                                                        <label className="checkBox">
                                                            <input type="checkbox" name="isBackupEnabled" checked={ this.state.instanceForm.isBackupEnabled } value={ this.state.instanceForm.isBackupEnabled } onChange={ this.formChangeHandler } />
                                                            <span className="checkmark"></span>
                                                            <p className="add_on_head"><strong>Enable Instance Backup:</strong> Protect your data and recover quickly in an emergency. <span className="usr_recomend">RECOMMENDED</span></p>
                                                        </label>
                                                        <p className="add_on_info">A system image backup of the instance will be performed on a daily basis. An additional amount of <strong>$0.05/GB</strong> will be charged per month.</p>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="addOn_container">
                                                        <label className="checkBox">
                                                            <input type="checkbox" name="privateIp" value={ this.state.instanceForm.privateIp } onChange={ this.formChangeHandler } />
                                                            <span className="checkmark"></span>
                                                            <p className="add_on_head">Private IP</p>
                                                        </label>
                                                        <p className="add_on_info">Add a private IP address to the instance to have a secure private communication with other instances within your account</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>
                                    <div className="compute_server_btn">
                                        <input disabled={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled }
                                            type="submit"
                                            name=""
                                            value="Create"
                                            className={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled ? "common_cta_btn blue create_vm_btn disabled" : "common_cta_btn create_vm_btn blue" }
                                            onClick={ this.handlesubmit }
                                        />
                                    </div>
                                    <section className="other-final_create_sec" id="other-final_create_sec">
                                        <div className="finalCreate_col">
                                            <div className="col1">
                                                <label className="txtBox_label">Number of Unit </label>
                                                <span className="label_info">Multiple instances can be created with the same configuration</span>
                                                <div className="unit_box add_remove_field">
                                                    <span className="sub_icon" onClick={ () => this.bmrFunLimit("decrease") }><span className="icon"></span></span>
                                                    <input type="text" id="unitbox" name="unit" value={ this.state.instanceForm.unit + " Unit" } onChange={ this.formChangeHandler } />
                                                    <span className="add_icon" onClick={ () => this.bmrFunLimit("increase") }><span className="icon"></span></span> </div>
                                                <span className="comm_error_msg" >{ this.state.unitErrorMessg }</span>
                                            </div>

                                        </div>
                                    </section>
                                    <section className="other_details other_details_sec" >
                                        <h3>Other Details(Optional)</h3>
                                        <div className="text-area-wrap">
                                            <p className="h3_title_txt">Specify any additional requests in the box below.</p>
                                            <div className="text-area">
                                                <textarea rows="8" name="bmrQuery" value={ this.state.bmrQuery } onChange={ this.setBmrQueries }></textarea>
                                                <span className="error_msg_text" style={ { display: "none" } }>Textare is invalid</span> </div>
                                        </div>
                                        <div className="important-details">
                                            <h3>Important:</h3>
                                            <div className="details">
                                                <div className="icons"> </div>
                                                <div className="text"> It may take 2-6 weeks to provisions the bare metal instance. </div>
                                            </div>
                                            <div className="details">
                                                <div className="icons"> </div>
                                                <div className="text"> Once the bare metal instance is provisioned, you will be notified via email and dashboard messages. </div>
                                            </div>
                                            <div className="details">
                                                <div className="icons"> </div>
                                                <div className="text"> You will be billed in advance for the bare-metal instance. The charges will be applicable immediately after the bare metal instance is provisioned for your account.</div>
                                            </div>
                                        </div>
                                        <div className="submit-btn">
                                            <input type="button" name="" value="Submit Request" className={ this.state.isRequestSubmitted ? "common_cta_btn blue submitReq_btn disabled" : "common_cta_btn blue submitReq_btn" } disabled={ this.state.isRequestSubmitted } onClick={ (e) => this.checkBmrInputs(e) } />
                                        </div>
                                    </section>

                                </div>
                            </div>
                            <div className="unit_summary_rhs">
                                <div className="head_block">Instance Summary</div>
                                <div className="summary_list">
                                    <ul>
                                        <li>
                                            <h4>Region</h4>
                                            { this.state.instanceForm.region ? <div className="summary_info">{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })
                                            </div> : null
                                            }
                                        </li>
                                        <li>
                                            <h4>Version</h4>
                                            { this.state.instanceForm.distName ? <div className="summary_info">{ this.state.instanceForm.name }</div> : null }
                                        </li>
                                        <li>
                                            <h4>Plan</h4>
                                            { this.state.isPlanAvailable ?
                                                this.state.instanceForm.ram ? <div className="summary_info"><span><b>{ this.state.instanceForm.parentProc }</b> Processor</span> <small><b>{ this.state.instanceForm.processor }</b> cores / <b>{ this.state.instanceForm.threads }</b> threads</small>, { Number.isInteger(convertgbtotb(this.state.instanceForm.storage)) ? convertgbtotb(this.state.instanceForm.storage) + ".0 TB " : Number(this.state.instanceForm.storage.slice(0, -2).trim()) < 1024 ? this.state.instanceForm.storage : convertgbtotb(this.state.instanceForm.storage) + " TB " } { this.state.instanceForm.diskType } Storage, { this.state.instanceForm.ram } RAM, { plan_type }</div> : null
                                                :
                                                this.state.instanceForm.ram ? <div className="summary_info">{ this.state.instanceForm.processor }, { this.state.instanceForm.storage } NVMe Storage, { this.state.instanceForm.ram } RAM, { plan_type }</div> : null
                                            }
                                        </li>
                                        <li>
                                            <h4>Name</h4>
                                            <div className="summary_info">{ this.state.instanceForm.unitName }</div>
                                        </li>
                                        <li>
                                            <h4>Units</h4>
                                            <div className="summary_info">{ this.state.instanceForm.unit }</div>
                                        </li>
                                        { this.state.instanceForm.isBackupEnabled ?
                                            <li >
                                                <h4>Daily backup enabled*</h4>
                                            </li> : null
                                        }
                                    </ul>
                                    { (this.state.isYearly || this.state.isBmr) && this.state.instanceForm.ram &&
                                        <div className="ic_total_amt_stke"><span>${ this.state.instanceForm.unit * 12 * this.state.instanceForm.monthlyRate }</span>/year</div>
                                    }

                                    { this.state.isPrepaidMonthly && !this.state.isBmr && this.state.instanceForm.ram &&
                                        <div className="ic_total_amt_stke"><span>${ this.state.instanceForm.unit * this.state.instanceForm.monthlyRate }</span>/month</div>
                                    }

                                    { this.state.isYearly || this.state.isBmr ?
                                        <div className="total_amt">
                                            ${ this.state.instanceForm.unit * (this.state.instanceForm.monthlyRate * 12 - (this.state.instanceForm.monthlyRate * 12) / this.state.discVal) }/first year
                                        </div>
                                        :
                                        this.state.isPrepaidMonthly ?
                                            <div className="total_amt">
                                                ${ this.state.instanceForm.unit * (this.state.instanceForm.monthlyRate - (this.state.instanceForm.monthlyRate) / this.state.discMonVal) }/month
                                            </div> :
                                            <div className="total_amt">
                                                ${ this.state.instanceForm.unit * this.state.instanceForm.monthlyRate }/month
                                            </div>
                                    }

                                    { this.state.instanceForm.isBackupEnabled ?
                                        <div style={ { paddingLeft: '20px' } }>*Backups will incur an additional charge</div> : null
                                    }
                                    <input disabled={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled }
                                        type="button"
                                        name=""
                                        value="Create"
                                        className={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled ? "common_cta_btn blue create_vm_btn disabled" : "common_cta_btn create_vm_btn blue" }
                                        onClick={ this.handlesubmit } />
                                </div>
                                <div className="instance__note" style={ { display: this.state.isYearly || this.state.isBmr ? 'none' : '' } }>
                                    <strong>Note:</strong> A temporary authorization on the total monthly base rate of the instances being created will be placed to ensure there are sufficient funds. The actual charges may vary based on usage.

                                </div>
                            </div>
                        </section>
                        <div className="main_slider add_ssh_key" id="addshkey">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon"></div>
                                    <div className="sshKey_slide_wrap">
                                        <div className="head_block">
                                            <h2>
                                                <span className="icon_img">
                                                    <span className="icon"></span>
                                                </span>Add SSH Key</h2>
                                        </div>
                                        <div className="sshKey_content_wrap">
                                            <p className="error_msg" > { this.state.errorMessg } </p>
                                            <p className="info_txt" ><a href="https://www.idrivecompute.com/faq_instances.htm#generate-sshkey" target="_blank">See instructions to <b>generate a new SSH key</b></a></p>
                                            <div className="common_txtBox_row" style={ { display: "none" } }>
                                                <label>Region</label>
                                                <div className="summary_info">{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })</div>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <input placeholder="Provide a key name" type="text" name="sshName" value={ this.state.instanceForm.sshName } maxLength="20"
                                                    id="keyNameInp" className="txt_box" onChange={ this.formChangeHandler } autoComplete="off" />
                                                <span className="comm_error_msg" style={ { display: (this.state.sshEmpty ? 'inline-block' : 'none') } } >Name should not be blank</span>
                                                <span className="comm_error_msg" style={ { display: this.state.sshKeyRegex ? 'inline-block' : 'none', color: "red" } } >Key name can contains a-z, A-Z, 0-9, -, _ characters</span>
                                                <span className="comm_error_msg" style={ { display: this.state.sshNameError ? 'inline-block' : 'none' } } >Key name already exists</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>SSH Public Key</label>
                                                <textarea id="keyInp" name="sshPublickey" placeholder="Provide your SSH public key" value={ this.state.instanceForm.sshPublickey } onChange={ this.formChangeHandler }></textarea>
                                                <span className="comm_error_msg" style={ { display: this.state.sshPublickeyEmpty ? 'inline-block' : 'none' } } >Key should not be blank</span>
                                                <span className="comm_error_msg" style={ { display: this.state.sshPublickeyError ? 'inline-block' : 'none' } } >SSH key is invalid</span>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Add Key" onClick={ this.addSshkey } className="common_cta_btn blue" />
                                                <input
                                                    type="button"
                                                    name=""
                                                    defaultValue="Cancel"
                                                    className="common_cta_btn transparentGrey" onClick={ this.cancel } /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main_slider marketApp_slider" id="appSlider">
                            <div className="slider_bg_shadow"></div>
                            <iframe src="https://docs.idrivecompute.com/hc/en-us/articles/5802533828125-nakama" width="100%" height="300" title="" style={ { display: 'none' } }>
                            </iframe>
                            <div className="slider_wrapper" >
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ () => this.closeAppSlider() } data-tip data-for="appStackClose"></div>
                                    <ReactTooltip id="appStackClose">Close</ReactTooltip>
                                    <div className={ "marketApp_slider_wrap " + this.state.appSlider.key + "_blk active" } >
                                        <div className="head_block">
                                            <h2>Application Stack</h2>
                                        </div>
                                        <div className="marketApp_content_wrap">
                                            <div className="marketApp_titlebox">
                                                <div className="marketApp_titleboxContent">
                                                    <div className={ "marketApp_icon " + this.state.appSlider.key?.replace(/\s+/, "") }>
                                                        <i className="icon"></i>
                                                    </div>
                                                    <div className="marketApp_det">
                                                        <h4>{ this.state.appSlider.name }</h4>
                                                        <p><span>{ this.state.appSlider.version }</span></p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sql_table_blk">
                                                <h2>{ this.state.appSlider.heading }</h2>
                                                <p dangerouslySetInnerHTML={ { __html: this.state.appSlider.headingDesc } } ></p>
                                                { this.state.appSlider.packages.length > 0 && <h4>Packages Included</h4> }
                                                { this.state.appSlider.packages.length > 0 && <table>
                                                    <tbody>
                                                        <tr>
                                                            <th>Package</th>
                                                            <th>Version</th>
                                                            <th>License</th>
                                                        </tr>
                                                        { this.state.appSlider.packages.map((item, i) =>
                                                            <tr key={ i }>
                                                                <td>{ item.name }</td>
                                                                <td><a target="_blank" href={ item.verHref }>{ item.version }</a></td>
                                                                { item.lisHref ? <td><a target="_blank" href={ item.lisHref }>{ item.licesnse }</a></td> : <td>{ item.licesnse }</td> }
                                                            </tr>
                                                        ) }
                                                    </tbody>
                                                </table>
                                                }
                                            </div>
                                            <div className="lamp_deploy_desc">
                                                <h2>{ this.state.appSlider.heading01 }</h2>
                                                <ul>{ this.state.appSlider.heading01Desc && this.state.appSlider.heading01Desc.map((item, l) =>
                                                    <li key={ l }>
                                                        <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                                    </li>
                                                ) }

                                                </ul>
                                                { this.state.appSlider.heading1Desc.length > 0 && <h2>Getting Started after deploying { this.state.appSlider.name }</h2> }
                                                <p> { this.state.appSlider.heading1 }</p>
                                                <ul> { this.state.appSlider.heading2Desc.map((item, j) =>
                                                    <li key={ j }>
                                                        <a href={ item.desc } target="_blank">{ item.desc }</a>
                                                    </li>
                                                ) }

                                                </ul>
                                                <ul className="disk_list">
                                                    { this.state.appSlider.heading1Desc.map((item, i) =>
                                                        <li key={ i }>
                                                            <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                                        </li>
                                                    ) }
                                                </ul>
                                                { this.state.appSlider.restInfo && <p dangerouslySetInnerHTML={ { __html: this.state.appSlider.restInfo } } ></p> }

                                            </div>
                                            { this.state.appSlider.heading3 && <div className="lamp_deploy_desc">
                                                <h2>{ this.state.appSlider.heading3 }</h2>
                                                <ul className="disk_list">
                                                    { this.state.appSlider.heading3Desc.map((item, i) =>
                                                        <li key={ i }>
                                                            <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                                        </li>
                                                    ) }
                                                </ul>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
                <div className={ this.state.isBMRConfrimPopup ? "main_popup InstanceDetail_confirm active" : "main_popup InstanceDetail_confirm" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.setState({ isBMRConfrimPopup: false }); $("body").removeClass("no_scroll"); } }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Submit Bare-Metal Request</div>
                                </div>
                                <div className="popup_body">
                                    <div className="instanceDetails">
                                        <ul>
                                            <li>
                                                <div className="slct-lhs">Region</div>
                                                <div className="slct-rhs">{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })</div>
                                            </li>
                                            <li>
                                                <div className="slct-lhs">Plan</div>
                                                <div className="slct-rhs"><span><b>{ this.state.bmrParentProc }</b> Processor</span> <b>{ formatcpus(this.state.bmrProcessor) }</b> cores / <b>{ this.state.bmrThreads }</b> threads, { Number.isInteger(convertgbtotb(this.state.bmrStorage)) ? convertgbtotb(this.state.bmrStorage) + ".0 TB" : Number(this.state.bmrStorage.slice(0, -2).trim()) < 1024 ? this.state.bmrStorage : convertgbtotb(this.state.bmrStorage) + " TB " } { this.state.bmrDiskType } Storage, { this.state.bmrRam } RAM</div>
                                            </li>
                                            <li>
                                                <div className="slct-lhs">Units</div>
                                                <div className="slct-rhs">{ this.state.instanceForm.unit }</div>
                                            </li>
                                            <li>
                                                <div className="slct-lhs">Charges</div>
                                                <div className="slct-rhs">${ (this.state.bmrPrice * 12 - (this.state.bmrPrice * 12) / this.state.discVal) * this.state.instanceForm.unit }</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="condition_pointers">
                                        <strong>Note</strong>
                                        <ul>
                                            <li>Your credit card will be charged <b>${ (this.state.bmrPrice * 12 - (this.state.bmrPrice * 12) / this.state.discVal) * this.state.instanceForm.unit }</b> once you click 'Confirm'. </li>
                                            <li>Your billing cycle will start immediately after the bare metal instance is provisioned for your account.</li>
                                            <li>It may take 2-6 weeks to provision the bare-metal instance.</li>
                                            <li>You will be notified via email and dashboard messages when the bare metal instance is ready to use.</li>

                                        </ul>
                                    </div>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_cancel" onClick={ () => { this.setState({ isBMRConfrimPopup: false }); $("body").removeClass("no_scroll"); } }>Cancel</div>
                                        <div className="btn blue" id="redirect_instance_page" onClick={ () => this.submitBmrRequest() } >Confirm</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*block User*/ }
                <div className="main_popup blockUser_popup ">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.closeBlockUserPopup() }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> { this.state.userBlockType === "bmr" ?
                                        "Unable to submit request" : "Unable to Create Instance" }</div>
                                </div>
                                <div className="popup_body">
                                    { this.state.userBlockType === "bmr" ?
                                        <p>Your bare metal could not be submitted. <a target="_blank" href=" https://www.idrivecompute.com/support.htm">Contact support</a> for further assistance.</p>
                                        :
                                        <p>Your instance could not be created. <a target="_blank" href=" https://www.idrivecompute.com/support.htm">Contact support</a> for further assistance.</p>
                                    }
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn blue" onClick={ () => this.closeBlockUserPopup() }>OK</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End of block user */ }
                <CommonMessage message={ this.state.message } isUserSubscribed={ this.state.isUserSubscribed } msgType={ this.state.msgType } handler={ () => this.setState({ message: '' }) } />
            </body>
        );
    }
}


function formatcpus(param) {
    let data = param.split(" ");
    return data[0];
}

function getPsswdStrength(psswd) {
    // const strongPwd = new RegExp("^(?=.*[a-z])(?=(.*[A-Z]){2})(?=.*[0-9])(?=.*[=+-_!@#\$%\^&\*])(?=.{8,})([a-zA-Z])+$");
    //const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
    var str = psswd;
    var patt1 = new RegExp("^(?=.*[a-z])(?=(.*[A-Z]))(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])(?=.{6,})"); //middle 6 charecters
    var charRegEx = new RegExp("^[a-zA-z0-9]"); // 
    var charRegEx1 = new RegExp("^[a-zA-z]");
    var str2 = str.slice(1, -1);
    var char1 = str.charAt(0); // uppercase or number
    var char2 = str.charAt(str.length - 1);

    var result = charRegEx.test(char1) && patt1.test(str2) && charRegEx1.test(char2);

    if(result) {
        return "Strong";
    }
    // if(mediumPwd.test(psswd)){
    //     return "Average"
    // }
    return "Weak";
}


function getBytes(val) {
    var size = "";
    if(val.includes('MB')) {
        size = val.replace('MB', '').trim();
        return size * 1024 * 1024;
    }
    if(val.includes('GB')) {
        size = val.replace('GB', '').trim();
        return size * 1024 * 1024 * 1024;
    }
    if(val.includes('TB')) {
        size = val.replace('TB', '').trim();
        return size * 1024 * 1024 * 1024 * 1024;
    }
    if(val.includes('PB')) {
        size = val.replace('PB', '').trim();
        return size * 1024 * 1024 * 1024 * 1024 * 1024;
    }
}

function getDistUserName(type) {
    let user = type;
    if(type === undefined || type === '') {
        return;
    }
    for(let i = 0; i < distributionOption.length; i++) {
        let item = distributionOption[i];
        if(type.includes(item.type)) {
            user = item.user;
            break;
        }
    }
    return user;
}

function isCountLessthanThreshold(regionName, currentCount) {
    let instCountList = JSON.parse(localStorage.getItem('instCountList'));
    if(instCountList !== null && instCountList !== undefined) {
        let ob = instCountList.find(item => regionName === item.key);
        if(ob !== undefined) {
            let newCount = ob.count + currentCount;
            if(newCount > 25) {
                return false;
            }
        }
    }
    return true;
}



export default withStyles(styles)(CreateInstance);
